var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name2 in all)
    __defProp(target, name2, { get: all[name2], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// package.json
var package_exports = {};
__export(package_exports, {
  default: () => package_default,
  dependencies: () => dependencies,
  devDependencies: () => devDependencies,
  files: () => files,
  gitHead: () => gitHead,
  license: () => license,
  main: () => main,
  module: () => module,
  name: () => name,
  publishConfig: () => publishConfig,
  scripts: () => scripts,
  type: () => type,
  types: () => types,
  version: () => version
});
var name, version, files, type, main, module, types, license, publishConfig, dependencies, devDependencies, scripts, gitHead, package_default;
var init_package = __esm({
  "package.json"() {
    name = "@particle-network/auth";
    version = "1.3.0";
    files = [
      "lib",
      "es",
      "LICENSE"
    ];
    type = "module";
    main = "lib/index.js";
    module = "es/index.js";
    types = "lib/types/index.d.ts";
    license = "Apache-2.0";
    publishConfig = {
      access: "public"
    };
    dependencies = {
      "@particle-network/analytics": "^1.0.1",
      "@particle-network/chains": "*",
      "@particle-network/crypto": "^1.0.1",
      buffer: "^6.0.3",
      draggabilly: "^3.0.0"
    };
    devDependencies = {
      "@metamask/eth-sig-util": "^5.0.2",
      "@types/draggabilly": "^2.1.3",
      "ts-loader": "^9.3.1",
      "webpack-cli": "^4.10.0"
    };
    scripts = {
      clean: "shx rm -rf lib/* && shx rm -rf es/*",
      package: `shx echo '{ "type": "commonjs" }' > lib/package.json`,
      build: "yarn clean && node ./esBuild.js && tsc --emitDeclarationOnly -p tsconfig.json && yarn package",
      "dev:lib": 'cross-env NODE_ENV=development concurrently "tsc -w" "node ./esBuild.js"',
      "build:min.js": "webpack",
      version: "yarn build"
    };
    gitHead = "cc999e430ebfb1dd821783f7cf099ddd51f3495a";
    package_default = {
      name,
      version,
      files,
      type,
      main,
      module,
      types,
      license,
      publishConfig,
      dependencies,
      devDependencies,
      scripts,
      gitHead
    };
  }
});

// src/particle-network.ts
import { ActiveAction as ActiveAction3, BI as BI3 } from "@particle-network/analytics";
import { chains as chains2 } from "@particle-network/chains";

// src/auth.ts
import { ActiveAction as ActiveAction2, RecordType } from "@particle-network/analytics";
import { chains } from "@particle-network/chains";
import { urlCrypto as urlCrypto2, uuidv4 as uuidv42 } from "@particle-network/crypto";
import { Buffer as Buffer4 } from "buffer";
import { EventEmitter } from "events";

// src/controller.ts
var erc4337Option = false;
var controller = {
  languageCode: "en",
  fiatCoin: "USD",
  get erc4337() {
    return erc4337Option;
  },
  set erc4337(option) {
    erc4337Option = option;
  }
};

// src/locales/en.ts
var en = {
  title: "Approve Pop-up",
  content_sign: "Click Continue to complete the signature or transaction",
  content_login: "Click Continue to complete creating or connecting wallet"
};

// src/locales/ja.ts
var ja = {
  title: "\u627F\u8A8D\u30DD\u30C3\u30D7\u30A2\u30C3\u30D7",
  content_sign: "[\u7D9A\u884C] \u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u7F72\u540D\u307E\u305F\u306F\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u3092\u5B8C\u4E86\u3057\u307E\u3059",
  content_login: "[\u7D9A\u884C] \u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u4F5C\u6210\u307E\u305F\u306F\u63A5\u7D9A\u3092\u5B8C\u4E86\u3057\u307E\u3059"
};

// src/locales/ko.ts
var ko = {
  title: "\uD31D\uC5C5 \uC2B9\uC778",
  content_sign: "\uC11C\uBA85 \uB610\uB294 \uD2B8\uB79C\uC7AD\uC158\uC744 \uC644\uB8CC\uD558\uB824\uBA74 \uACC4\uC18D\uC744 \uD074\uB9AD\uD558\uC2ED\uC2DC\uC624.",
  content_login: "\uACC4\uC18D\uC744 \uD074\uB9AD\uD558\uC5EC \uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uC5F0\uACB0\uC744 \uC644\uB8CC\uD569\uB2C8\uB2E4."
};

// src/locales/zh_CN.ts
var zh_CN = {
  title: "\u6279\u51C6\u5F39\u51FA\u7A97\u53E3",
  content_sign: "\u70B9\u51FB\u7EE7\u7EED\u5B8C\u6210\u7B7E\u540D\u6216\u4EA4\u6613",
  content_login: "\u70B9\u51FB\u7EE7\u7EED\u5B8C\u6210\u521B\u5EFA\u6216\u8FDE\u63A5\u94B1\u5305"
};

// src/locales/zh_HK.ts
var zh_HK = {
  title: "\u6279\u51C6\u5F48\u51FA\u7A97\u53E3",
  content_sign: "\u9EDE\u64CA\u7E7C\u7E8C\u5B8C\u6210\u7C3D\u540D\u6216\u4EA4\u6613",
  content_login: "\u9EDE\u64CA\u7E7C\u7E8C\u5B8C\u6210\u5275\u5EFA\u6216\u9023\u63A5\u9322\u5305"
};

// src/locales/index.ts
function locale() {
  const code = controller.languageCode;
  if (code.startsWith("en")) {
    return en;
  } else if (code.startsWith("ja")) {
    return ja;
  } else if (code.startsWith("ko")) {
    return ko;
  } else if (code === "zh_CN" || code === "zh-CN" || code === "zh") {
    return zh_CN;
  } else if (code === "zh_HK" || code === "zh-HK" || code === "zh_TW" || code === "zh-TW") {
    return zh_HK;
  } else {
    return en;
  }
}

// src/components/logoBase64.ts
var logoBase64_default = `data:image/png;base64,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`;

// src/components/approvePopup.ts
var approvePopupContentHtml = (content) => `
    <div class="particle-pam-left">
      <div class="particle-pam-wrap">
        <div class="particle-pam-img">
          <img src='${logoBase64_default}' alt="" />
        </div>
        <div class="particle-pam-content">
          <div class="particle-pam-title">${locale().title}</div>
          <div class="particle-pam-text">${content}</div>
        </div>
      </div>
    </div>
    <div class="particle-pam-right parm-continue-btn">Continue</div>
`;
var style = `
.particle-approve-popup {
  position: fixed;
  z-index: 999999;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-radius: 6px;
  padding: 0px 18px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: #fff;
  -webkit-box-shadow: 4px 4px 20px 1px rgba(180, 180, 180, 0.6);
          box-shadow: 4px 4px 20px 1px rgba(180, 180, 180, 0.6);
  top: 30px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  right: -600px;
  width: 379px;
  height: 78px;
  padding-right: 0;
}
@media screen and (max-width: 600px) {
  .particle-approve-popup {
    max-width: 90%;
    left: 50%;
    -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
    padding: 0px 12px;
    right: 0;
    top: -100px;
  }
}
.particle-approve-popup.particle-approve-popup-show {
  right: 30px;
}
@media screen and (max-width: 600px) {
  .particle-approve-popup.particle-approve-popup-show {
    right: 0;
    top: 30px;
  }
}
.particle-approve-popup .particle-pam-left {
  position: relative;
  padding-right: 20px;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex:1;
}
@media screen and (max-width: 600px) {
  .particle-approve-popup .particle-pam-left {
    padding-right: 10px;
  }
}
.particle-approve-popup .particle-pam-left:after {
  content: '';
  position: absolute;
  width: 1px;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  right: 0px;
  top: 0;
  height: 100%;
}
.particle-approve-popup .particle-pam-left .particle-pam-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.particle-approve-popup .particle-pam-left .particle-pam-wrap .particle-pam-img {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  width: 42px;
  height: 42px;
  min-width: 42px;
  margin-right: 10px;
  border-radius: 42px;
  position: relative;
  overflow: hidden;
}
.particle-approve-popup .particle-pam-left .particle-pam-wrap .particle-pam-img img {
  width: 100%;
  height: 100%;
}
.particle-approve-popup .particle-pam-left .particle-pam-wrap .particle-pam-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.particle-approve-popup .particle-pam-left .particle-pam-wrap .particle-pam-content .particle-pam-title {
  font-weight: bold;
  font-size: 17px;
  color: #000;
}
.particle-approve-popup .particle-pam-left .particle-pam-wrap .particle-pam-content .particle-pam-text {
  font-size: 12px;
  color: #666;
  opacity: 0.8;
  line-height: 12px;
}
.particle-approve-popup .particle-pam-right {
  position: relative;
  cursor: pointer;
  font-size: 14px;
  color: #2d6af6;
  font-weight: bold;
  margin-left: 20px;
  height: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  min-width: 88px;
  padding: 0 10px;
  margin: 0;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.particle-approve-popup .particle-pam-right:hover {
  color: #2d6af6;
  font-weight: bold;
}
`;
var approvePopupRenderStyle = () => {
  const className = "particle-approve-popup-style";
  const el = document.querySelector("." + className);
  el && el.remove();
  const styleEl = document.createElement("style");
  styleEl.classList.add(className);
  styleEl.innerHTML = style;
  document.head.appendChild(styleEl);
};
var approvePopupRender = (callback, key) => {
  approvePopupRenderStyle();
  const className = "particle-approve-popup";
  const el = document.querySelector("." + className);
  el && el.remove();
  const particleApprovePopupEl = document.createElement("div");
  particleApprovePopupEl.classList.add(className);
  particleApprovePopupEl.innerHTML = approvePopupContentHtml(locale()[`content_${key}`]);
  document.body.appendChild(particleApprovePopupEl);
  setTimeout(() => {
    particleApprovePopupEl.classList.add("particle-approve-popup-show");
  });
  const parmContinueBtn = document.querySelector(".parm-continue-btn");
  parmContinueBtn && parmContinueBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    particleApprovePopupEl.classList.remove("particle-approve-popup-show");
    callback && callback();
  });
};

// src/utils/utils.ts
import { v4 as uuidv4 } from "uuid";
var HTTP_REGEX = "^https?:";
function getUrlProtocol(url) {
  const matches = url.match(new RegExp(/^\w+:/, "gi"));
  if (!matches || !matches.length)
    return;
  return matches[0];
}
function matchRegexProtocol(url, regex) {
  const protocol = getUrlProtocol(url);
  if (typeof protocol === "undefined")
    return false;
  return new RegExp(regex).test(protocol);
}
function isHttpUrl(url) {
  return matchRegexProtocol(url, HTTP_REGEX);
}
function isNullish(value) {
  return value === null || value === void 0;
}
function getParticleEnv() {
  if (typeof window !== "undefined") {
    if (window.__PARTICLE_ENVIRONMENT__ === "staging" || window.__PARTICLE_ENVIRONMENT__ === "development") {
      return window.__PARTICLE_ENVIRONMENT__;
    }
  }
  return "production";
}
function isSafariOrIOS() {
  const ua = navigator.userAgent;
  return /Version\/([0-9\\._]+).*Mobile.*Safari.*/.test(ua) || /Version\/([0-9\\._]+).*Safari/.test(ua) || /iP(hone|od|ad)/.test(ua);
}
var isBraveBrowser = () => {
  return typeof window !== "undefined" && navigator.brave;
};
var isFireFox = () => {
  return typeof window !== "undefined" && /Firefox\/([0-9.]+)(?:\s|$)/.test(navigator.userAgent);
};
var isChrome = () => {
  return typeof window !== "undefined" && /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\\.]+)(:?\s|$)/.test(navigator.userAgent);
};
var isBlockingThirdpartyCookiesBrowser = (chromeExclude) => {
  return isSafariOrIOS() || isBraveBrowser() || isFireFox() || isChrome() && !isBraveBrowser() && !chromeExclude;
};
function getDeviceId() {
  if (typeof window === "undefined") {
    return uuidv4();
  } else {
    const storeKey = "pn_device_id";
    let deviceId = localStorage.getItem(storeKey);
    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem(storeKey, deviceId);
    }
    return deviceId;
  }
}
function getVersion() {
  const packages = (init_package(), __toCommonJS(package_exports));
  return `web_${packages.version}`;
}
function popupWindow(url, title, w, h) {
  const left = screen.width / 2 - w / 2;
  const top = screen.height / 2 - h / 2;
  return open(
    url,
    title,
    "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left
  );
}

// src/utils/tron/crypto.ts
import { Buffer as Buffer2 } from "buffer";
import CryptoJS from "crypto-js";

// src/utils/tron/base58.ts
var ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var ALPHABET_MAP = ALPHABET.split("").reduce((acc, x, i) => {
  acc[x] = i;
  return acc;
}, {});
var BASE = 58;
var encode58 = (buffer) => {
  if (buffer.length === 0)
    return "";
  const digits = [0];
  for (let i = 0; i < buffer.length; i++) {
    for (let j = 0; j < digits.length; j++)
      digits[j] <<= 8;
    digits[0] += buffer[i];
    let carry = 0;
    for (let j = 0; j < digits.length; ++j) {
      digits[j] += carry;
      carry = digits[j] / BASE | 0;
      digits[j] %= BASE;
    }
    while (carry) {
      digits.push(carry % BASE);
      carry = carry / BASE | 0;
    }
  }
  for (let i = 0; buffer[i] === 0 && i < buffer.length - 1; i++)
    digits.push(0);
  return [...digits].reverse().map((digit) => ALPHABET[digit]).join("");
};
var decode58 = (data) => {
  if (data.length === 0)
    return [];
  const bytes = [0];
  for (let i = 0; i < data.length; i++) {
    const c = data[i];
    if (!(c in ALPHABET_MAP))
      throw new Error("Non-base58 character");
    for (let j = 0; j < bytes.length; j++)
      bytes[j] *= BASE;
    bytes[0] += ALPHABET_MAP[c];
    let carry = 0;
    for (let j = 0; j < bytes.length; ++j) {
      bytes[j] += carry;
      carry = bytes[j] >> 8;
      bytes[j] &= 255;
    }
    while (carry) {
      bytes.push(carry & 255);
      carry >>= 8;
    }
  }
  for (let i = 0; data[i] === "1" && i < data.length - 1; i++)
    bytes.push(0);
  return bytes.reverse();
};

// src/utils/tron/crypto.ts
var sha256Hex = (msg) => CryptoJS.enc.Hex.stringify(CryptoJS.SHA256(CryptoJS.enc.Hex.parse(msg)));
var toBase58Address = (hex) => {
  const addr = `41${hex.substring(2)}`;
  const doubleSha256 = sha256Hex(sha256Hex(addr));
  const checkSum = doubleSha256.substring(0, 8);
  const address = Buffer2.from(addr + checkSum, "hex");
  return encode58(address);
};
var toHexAddress = (base58Sting) => {
  if (base58Sting.length <= 4)
    throw new Error("Invalid address provided");
  let address = Buffer2.from(decode58(base58Sting)).toString("hex");
  const checkSum = address.substring(address.length - 8, address.length);
  address = address.substring(0, address.length - 8);
  const checkSum1 = sha256Hex(sha256Hex(address)).substring(0, 8);
  if (`${checkSum}` === `${checkSum1}`)
    return `0x${address.substring(2)}`;
  throw new Error("Invalid address provided");
};

// src/constant.ts
var authUrl = () => {
  const productionAuthUrl = "https://auth.particle.network";
  const stagingAuthUrl = "https://auth-staging.particle.network";
  const developmentAuthUrl = "https://auth-debug.particle.network";
  const env = getParticleEnv();
  if (typeof window !== "undefined" && window.__PARTICLE_AUTH_LOCALHOST__ && typeof window.__PARTICLE_AUTH_LOCALHOST__ === "string" && window.__PARTICLE_AUTH_LOCALHOST__.includes("localhost")) {
    return window.__PARTICLE_AUTH_LOCALHOST__;
  }
  switch (env) {
    case "production":
      return productionAuthUrl;
    case "staging":
      return stagingAuthUrl;
    case "development":
      return developmentAuthUrl;
  }
};
var apiUrl = () => {
  const productionApi = "https://api.particle.network";
  const developmentApi = "https://api-debug.particle.network";
  const env = getParticleEnv();
  return env === "development" ? developmentApi : productionApi;
};
var rpcUrl = () => {
  const productionApi = "https://rpc.particle.network";
  const developmentApi = "https://rpc-debug.particle.network";
  const env = getParticleEnv();
  return env === "development" ? developmentApi : productionApi;
};
var walletUrl = () => {
  const productionUrl = "https://wallet.particle.network";
  const stagingUrl = "https://wallet-staging.particle.network";
  const developmentUrl = "https://wallet-debug.particle.network";
  const env = getParticleEnv();
  switch (env) {
    case "production":
      return productionUrl;
    case "staging":
      return stagingUrl;
    case "development":
      return developmentUrl;
  }
};
var buyUrl = () => {
  const productionUrl = "https://ramp.particle.network";
  const stagingUrl = "https://ramp-staging.particle.network";
  const developmentUrl = "https://ramp-debug.particle.network";
  const env = getParticleEnv();
  switch (env) {
    case "production":
      return productionUrl;
    case "staging":
      return stagingUrl;
    case "development":
      return developmentUrl;
  }
};

// src/utils/wallet-url.ts
import { urlCrypto } from "@particle-network/crypto";
import { Buffer as Buffer3 } from "buffer";

// src/types.ts
var AuthError = class {
  constructor(code, message) {
    this.code = code;
    this.message = message;
    this.code = code;
    this.message = message;
  }
  static userCancelOperation() {
    return new AuthError(4011, "The user cancel the operation");
  }
  static unauthorized() {
    return new AuthError(4100, "The requested method and/or account has not been authorized by the user");
  }
  static unsupportedMethod() {
    return new AuthError(4200, "The Provider does not support the requested method");
  }
  static unsupportedChain() {
    return new AuthError(4201, "The Provider does not support the chain");
  }
  static paramsError() {
    return new AuthError(8002, "Param error, see doc for more info");
  }
  static notLogin() {
    return new AuthError(8005, "User not login");
  }
  static walletNotCreated() {
    return new AuthError(8006, "Wallet not created");
  }
  static decrypt(message) {
    return new AuthError(8007, "decrypt error: " + message);
  }
};
var AuthTypes = [
  "email",
  "phone",
  "facebook",
  "google",
  "apple",
  "discord",
  "github",
  "twitch",
  "twitter",
  "microsoft",
  "linkedin",
  "jwt"
];
var SettingOption = /* @__PURE__ */ ((SettingOption2) => {
  SettingOption2[SettingOption2["None"] = 0] = "None";
  SettingOption2[SettingOption2["Once"] = 1] = "Once";
  SettingOption2[SettingOption2["Always"] = 2] = "Always";
  SettingOption2[SettingOption2["Force"] = 3] = "Force";
  return SettingOption2;
})(SettingOption || {});

// src/utils/wallet-url.ts
function getWalletUrl(auth, config) {
  var _a, _b, _c, _d, _e;
  if (!auth.isLogin()) {
    throw AuthError.notLogin();
  }
  if (!auth.walletExist()) {
    throw AuthError.walletNotCreated();
  }
  const { projectId, clientKey, appId, chainName, chainId, securityAccount } = auth.config;
  let supportChains = ((_b = (_a = auth.config.wallet) == null ? void 0 : _a.customStyle) == null ? void 0 : _b.supportChains) || ((_c = auth.config.wallet) == null ? void 0 : _c.supportChains);
  if (supportChains && auth.config.chainId && auth.config.chainName) {
    if (!supportChains.find(
      (item) => {
        var _a2;
        return item.id === auth.config.chainId && item.name.toLowerCase() === ((_a2 = auth.config.chainName) == null ? void 0 : _a2.toLowerCase());
      }
    )) {
      supportChains.unshift({
        id: auth.config.chainId,
        name: auth.config.chainName
      });
    }
  }
  supportChains = supportChains == null ? void 0 : supportChains.map((chain) => {
    const { id, name: name2 } = chain;
    return {
      id,
      name: name2
    };
  });
  const customStyle = (_d = auth.config.wallet) == null ? void 0 : _d.customStyle;
  if (customStyle) {
    customStyle.supportChains = supportChains;
    if (!customStyle.fiatCoin) {
      customStyle.fiatCoin = controller.fiatCoin;
    }
  }
  const params = {
    projectId,
    clientKey,
    appId,
    chainName,
    chainId,
    securityAccount,
    authUserInfo: auth.getUserInfo(),
    authType: auth.getAuthType(),
    authSDKVersion: (_e = window.particle) == null ? void 0 : _e.version,
    supportChains
  };
  const ciphertext = urlCrypto.encryptUrlParam(params);
  let url = `${walletUrl()}/?params=${ciphertext}&theme=${getWalletUIMode(auth)}&language=${controller.languageCode}`;
  if (customStyle) {
    url += `&customStyle=${encodeURIComponent(Buffer3.from(JSON.stringify(customStyle)).toString("base64"))}`;
  }
  const { uiMode, modalBorderRadius } = auth.getAuthTheme();
  url += `&authTheme=${encodeURIComponent(
    Buffer3.from(
      JSON.stringify({
        uiMode,
        modalBorderRadius
      })
    ).toString("base64")
  )}`;
  if (config && config.topMenuType) {
    url += `&topMenuType=${config.topMenuType}`;
  }
  if (controller.erc4337) {
    url += `&erc4337=${encodeURIComponent(JSON.stringify(controller.erc4337))}`;
  }
  return url;
}
function getBuyUrl(auth, options) {
  var _a, _b, _c;
  let url = `${buyUrl()}/?language=${controller.languageCode}&theme=${getWalletUIMode(auth)}`;
  const customStyle = (_a = auth.config.wallet) == null ? void 0 : _a.customStyle;
  if (customStyle) {
    const { light, dark } = customStyle;
    url += `&customStyle=${encodeURIComponent(Buffer3.from(JSON.stringify({ light, dark })).toString("base64"))}`;
    if (!customStyle.fiatCoin) {
      customStyle.fiatCoin = controller.fiatCoin;
    }
  }
  if (auth.isLogin() && auth.walletExist()) {
    if (options) {
      if (!options.walletAddress) {
        options.walletAddress = (_b = auth.getWallet()) == null ? void 0 : _b.public_address;
      }
      if (!options.network) {
        options.network = auth.config.chainName;
      }
    } else {
      options = {
        walletAddress: (_c = auth.getWallet()) == null ? void 0 : _c.public_address,
        network: auth.config.chainName
      };
    }
  } else {
    if (!options || !options.network || !options.walletAddress) {
      throw new Error("network or walletAddress not found");
    }
  }
  if (options) {
    Object.keys(options).forEach((key) => {
      const value = options[key];
      if (value) {
        url += `&${key}=${encodeURIComponent(value)}`;
      }
    });
  }
  return url;
}
function getWalletUIMode(auth) {
  var _a, _b, _c;
  let walletUIMode = auth.getThemeType();
  if ((_a = auth.config.wallet) == null ? void 0 : _a.uiMode) {
    walletUIMode = ((_b = auth.config.wallet) == null ? void 0 : _b.uiMode) === "auto" ? window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : (_c = auth.config.wallet) == null ? void 0 : _c.uiMode;
  }
  return walletUIMode;
}

// src/components/walletEntry/html.ts
var html = `
  <button class="particle-pwe-btn">
    <img class="particle-pwe-img particle-pwe-wallet-icon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" alt="" />
    <img class="particle-pwe-img particle-pwe-down-arrow particle-pwe-down-arrow-hide" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" alt="" />
  </button>
  <div class="particle-pwe-iframe-content">
  </div>
`;
var walletEntryRender = () => {
  const className = "particle-wallet-entry-container";
  const el = document.querySelector("." + className);
  el && el.remove();
  const EL = document.createElement("div");
  EL.classList.add(className);
  EL.innerHTML = html;
  document.body.appendChild(EL);
};
var html_default = walletEntryRender;

// src/components/walletEntry/iconsBase64.ts
var walletIconDarkBase64 = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAAAXNSR0IArs4c6QAAIABJREFUeF7dfQlwXdWZ5neenvanXbKNWWRWIxkIiwgTQmwSSIPorsmiOEhqZEjiHjuTiUUcsqjLnqbHrjipqXhipqobd1HdiQWWXY4gSXfaIsGAFDLNopiwWLLxIj0veJFkWct72t67Z+o/9913t3OX9yQZ05dyCVt3Oef+5/+/71/Ofxn+kxxvPHz2E/EgX8bjWAaGag4s5GD5Cud5jLE8hSMfDEWKmC8bUcAjjLFoXFF/KmBnAXZAAT8AKAdq2xa++5/h1bCP4yTerj+9JM6U+znY5xSghoNdT/Pg4g9L/NT+rv4EGFThIvFTfp52feK8w5yx1xWOfZkBtu+h58pOftze18dCwPtXnq5AULkfjN2nKPgcY+xqRYiNhKb9VIXIxX+q8My/N5+nXWc8X71Ofl7i/MOcYR8Utm86Pt351T2XDVzqAr9kBfzKvTxYvvDUgzzAmhTgv3KwHFVougZqGqlqrn8NdtN0iwaL58nOBxBROJ5njLW+u7R035NPMm04l5TMLzkBv//w8Tt5IKOJc9SDsQpdw1w1yyAEfxpsvK9c490tgK7p4nkfgmNnnLNf1O8uff9SkvAlI+BDDR/eE4fyQw72l2aNdNIgdwy13kM1396abtRg7fwEMXO9XrMsnLN/Uxh+0thW+tqlIOiPXMCHHj5RywOBv1XA7zFiplEYMqy1YrBuRo2abjTnzhisEzArptuvtz/H4b4cf+CM/6ixrazjoxT0RyJg/iQPfHDw5BcAtICxO81Y6ovd2giVEwY7Y7aZkGnX29m2E7ZbCZ0DO2fsLYXjR0eXFv/mo8Dpiy7g3lUny4Iz+F8cfC3AAlYWrLNbHQN9sNt5x2Bntu1kGVSXTcyHMUVR+D/yrODfPbqjcOhiavRFEzAHZ331J1crDFs4UOZfU2blxyZxczYYLGfdZkvj5YcnsH0IjP2gaWfRPzMwzSmYV3lfFAH3P9J/ezyW8X/BcLeXf2rWFKNw/bNoWVDD2V92uq/VJVPP8xq/+TlG827iBv8vHlD+5uvPlfXMq3TFiOf56P/rE7Vc4c9ysFIn4pQeu5VjqDWS5Ry58sZg93FZgyIpRcjIfJ9XFPbIN3YX7Z1PEcybgPlKnnE8eHIz5/wHnDFmjhD5Ybdufqic3fph20ZC536++fmpWhYj27ZziOT4OQd+HIoVbfzqHhafD0HPi4D7VvYtyghm7OLACmd2a40Nm82ZXRNTiSXLXSU3jUz6sYZwpbcG6361GYP1YIvb/A337wzEgvVf2xM6M9dCnnMBH3/4+LUsgBcV8Gt1YuMZ4zUkALSX44aNur+aLrv1GyHTgxz+ImSyGLcvy8JxVOF4YM3u4qNzKeQ5FfCJhhMrGPgeDlTYo1F21uknQiTzT9PXLHOGScaOjQTNDzewn+/Xj5di9kCc46G1u4q750rIcybgk43hlYyzVgU826q58+nHyvxmeWTKbBGMsWTnSJbZUvi576z9eM6jPIDH1uws3jMXQp4TAX/YEH4cwFZy6Z3ysTJMtWu5ez7Xj0bNNpbsV4NT9ePtWSoXTVfRYP2atqKfzVbIsxbwmYa+Bs4ynlU4D8wmlmzEOj9+rD+sSz+WbA+f+sPgVNm2UeMtlo6G8OjatqJnZyPkWQn4dH3fvYwFfq8AQZ+RHDFWGXG5ZGPJjvlgo/lOJ0vlw4/niIHxB77ZVvxyukJOW8CnHz5+ZyCD71M4L5Bhk08/MFmRYT/f3Q/2Pn92fqy2CI2WIjXLMmd+/BhjuP+bO4veTEfIaQn4dEN4WYChk3OKKWsa6c+PNbJiZwy2+5GpxZL1sKKTZZBFvLRFYzabzvloc42Xv/k7R9Ycw5pk8YbiCr9rXRouVMoC5isPZA0GQ/sV8GVu/p1zbZR8ZRs1MtUIU6rs1ox1Tv62cZF89H4853h/IF5wx5N72HQqmpyygAcbwj9TwJudNdG/HyjzQ/3HktPRLLsfLDO7fti9e4zb/Tnp+vEK+LZvtxWRx+L7SEnAg/X9X+IMzxsn5yefa9fIuY0lG2uqciuDuKIuhNKabMSiHCM90/iwYwLDPVOmktqMPIbrmwqQUxEQOZfR8AyOd0whMhBLZo00TXeJJc+aQ6Tqx3Owr3y7raDdr4R9C/jcyr5FgSDr5UAxrUB3P1COof7rknWzmYqlKF+Ri2vXFEnn/sH2MZzunBDpvvzKIG7bWIJgnnn6tCDe3jqKoZ5pSX21NRLnZqnc5y+3XK4YbFh0GA7EAtXf8hm39iVgKrE5fzD8OzDcZ2WX6eVZ5z6WHMgL4NanKkCa6XS80TyEiYE47nmmwiZc7ZqZKEfXuvOYjtLMZPlfN3ZsxOrUY+lmSye/XiwOxl46f0PoAT8lQL4EPFzf95jC2L8YsSNVDJJFmFLB4Iy8DJTX5qOiNg8ZeQHEowqG35rE8dZxxKIKSHuvcdBeTXhHW8dBArxxTYGrhXtv+zhOdk4Kbc+tyMDly7OTGnSiawrjA2pmbz5j6XLvxIDtjDU07yzY5WWqPQU88PWDBcGJnGMKeLk7azbUICVXvizv67wynbCahHvNxlLkVmba5hMNz+DgpmEsqM0T2Ot2nOqIYiaiYInHeUfaozjcHsWS2lxUNeXbbvn29gj6OydNOyfkfrnz/P358fagkG4x2Ymp3MllP/jnijG3OXsKeLih72ccaJbHkmV5T+86ZvdIlr0Gq6KuAIvqnLVusGsC0XAMVzW5a2Z/e0S8iyV1dqEZX9KR9ggmBjluXuO8YF7bPIYBKVZ7z18mXCtz9/b7RX5823faClxZtauARx85tjQeZwcAluHElucSg50waNkzi4RZdjv+3DyAW7dVuJ7zzuYLQoNrtpS6nvfm5hEhXDLPTsdgzwz+sHlMyqIvoh8fnwG/6Ym2woNO43QV8IWGvpc58FkjVhqxwQ8GmV0qdRh+/EDjc27eudgLanBw83mEqrIczfTZrgkcfHpMPPvWjcUorsqS3vNc9zR6WyNYsa3E85kvNA75YNv+arWM3oJzhEziXzO27/GdBfenLOBhkUhgr8grH9yzNN67++RhPVr5WZVBEOZODcYwPaAIDbnFh4D/tPqc8HsX1+VjcW2+iU0T9oZ/GRG/p5dH7tHStYWoqCHypB/DvTPY/9MRzESBB3eW+xDweRcNpsuNOyWM3MN5/s5xBSfXixOt/ux3dhW8KhuwowaPNPR1cOABp1iuHSO8Y7FumptbnY3L1pQg02AWIz1TON06CsLgopocxxc+2juNg5voZesvtag6W2jreH8MMwaXx6gp5A+XVGcJl2isP4bRcCyhkRz3P1Pu6ErRU6KDCl5cdwG5FQFcdkcWMvMZpiMcfV3T4n5anCAVP96IzX4wWL83XvxOW8GDvgUceaT/9liMd/NkdbZ9H67b/txUMSi3OgdXbpBrDLlD4a0XULm+WIrD9Hti0ePhGanGeLNVM6vXLNa1dbm43oWM7d8eQV55ADfW5ZreK7lhf26dwNEky7Zqsvr3VGvCnCNeYvyc8/gn10tKfaQaPFrf9yvO8AWZxhmxMRU/1q1S4upti0yaa12Jw11RDOyNYvGqQoGz2jHWO43jO8YQEcJNFeu8/dib14ZwxXK75TjaMYGZCMeNdXmOVuW1rRGc6FbzAnKu4h1Ld+cqFm+D49frdxV80Togm4AjD/ffHg/wbiq/MQ7OSWOda5DURzlFvrTFQZhbuWWhK96Rlr6/+owwn5kVAWRVZCLSP4O4wFSXiI8pWa+d53a+OYlPgyqpzkRpVSbKqjMxEo7heOcURsJxPPRMKTJdombD4ThebBl1nb+3pTP7wdr5Mo7DOTjn/Mbv7i78wPgybQIeE34vZYvssVd7LNnZD/aHQRxknq9wMM/Ggb7TeFrCvo1lNGaGSUTtsto8FFZlYqR3BuQDaxpBfjCx6LHwDI61R0V0y+qHus2/tDoT92wo9CRhbY3DLhrstDvR27LQWO3CFtdte8LiF5sEzP9bd+b4aOkpbtpZL8cQ7x4Xck2xBjlYHsN1z7i7QdODcfSuO5tS741btpQi3xD5IiZ9dMc4rlkVwhUP6qaVYtNvtAxjOqqO1xsbgfLqLHx6g3tQhd7arsZhmwbbOYHTe9LGoxUi+qgJY+xcKJR/xZp/YipmWfcmjTb0fZEBL9hXs17tSBf58WMNDM8Tg67YWI68KrPLYlSPs+1jONM+Lu2eQ5p6RVMBsisyQGz6zN4J5C0JonqD3Y/94+oBfPoZezCkZ/sYzr41hatq81BSlSlY95H2CWGSZf4p/ZuXiY4MKvjNuhExDTlX8Rvxcr/ezm34l55oK/yVVMCRxr5fxTn/gkbR08Vg99olfWVqZiaQl4HKHy9AZrk9cjQRnsHhlkGTZhkxqGpLGfIMmnq+exJnOiakAu5qPIflOxfYTCsJuPyOLCww+MVktjvXncdUQrOtHGRpXa4nyTrZPT0vGCyvYFH1lXO++4ldBfU2AY+tPFzBghmnOJApW3HyygdvDHZmkWYMolBk+aoiFNbkgFJ/M4NxDHdGQdrrNJ786iws3WAPO77bMoSl3y1GtmHBXOidxjubLuBai4mm4Mdr64Zw7zN2N+2NzSOgkKSGeVbLdfvafFwlMk3m4/32CfR3TaOoMoj88gDO9M5gOKwuEf3P3GCwxDsZz41NXPatPQvGTSZ6vOHo40Dg//jBICP7+yj3BhVUZ+MGiYD3N6saf2VdSJjukR4iWTRfdQObIFnVmcLV+aB1HBMDCu7faTfd+7eO4XT3lLQfl6bRRZUZWFSjBjrofn1dU7j+wRzcUGt2r872xNC5NSIsQro1Yd4RQnXRKIx97fs7Qz83CTjScOznHHjUaWeCmx+bnr+cOgaRdl+1tkgEPMZ6pnGidRRL1haZTDTh8IFNw46sWLco5uffsCofVxnIF0W1KCZN6cLCyqBg2gdaozieyBObNVHXzFtX5QkByw5ynX63aTwhZPPznS2d03tyZdu/+F5b6DGrgPs5WKW3BqfB7iQxWSPVl2OKmV2S/3vDFqrY0LNKlAs+snUYi+sKkEUkq2cap/dGRcxZ33tk9QKc/WAiWRU1WaLqo3fHOD65sVgI13j8UZhtjXyZzWx+RQZqt8lLhrR7dLdOoGcv1YdZx2X+uyYH+44Pd+8kYVnC32sLLUkKeKK+b4nCeJ8bO3aPPc++WtGoWbLIT8mKfFwpqdjobjyT7EHpNf5UsjRkyWolCYdD7VEcbFdru6zc4PraHHyiyTm6RXM82xvDi5uMHoFWFpS+dyLr+BfjwatbduX2Cz94vLHvMXD+L5ofmGqExQ82yIrJ3Z9jthREqK7dIOrskwdFsvavpj3T2uZwsx/rXFPlb8/S5yUJB6rm0M20uV66ui4X9MftIAGTmbZH+OSWxug3u3sn6vVJC8zxte/vCv08IeBjuxjHw3YnXB2qPhj1795+sNGM+PMDzRgkY+cMS9aXmLJK/dtHMJiolJSxU3KfqHx2qHsKY+EYLk9g7PGOqGEesg546vPJbfrE2lAyq3SmexpvbtVYvX1ei2uycPd697Kho13T+OPTUal/ne6eLRk7B5jAYSHgSMOxfgCV5jpgq3A1ofnFYPP1Rmz3U62oDdqKQYU12cipzMSF7ilRpmONRRNWl96Rg3Ndk1i2sUSUyBImH2sdww1r1PDiwe1jAmdDV2XiVBdhtjFwb16cORUZAocpBTgTAWrWh5BHzDwcw/6noxgOkxulV1/WPlUkXCOn44XmEYwNqAzBzYI5CM0j9m6yYIe+31ZwI+NNZ/KjsegogIDxpn5jyW6s24+mp19tqU9GwyAiYJ94ivK4AZzvnkJGPkNRVRYmB+M4/PQYbt5QLF7rkdZxXNekatrprkkcSFR6yOavWZbMvAA+91SJKcEQHVDQ0XwhISzV0hVXBnHvxgJpIuI/tkdxpJNqrnXhzsX8ze85uVjjlbH8bDbe2Hcr4/xt1fT6res1J/f9sGBz1sm7y47LvlkLbHBRAVJck41oOI6qjSWimoMiWkeeHkPJndnCD44OxBCqzBRCII2muiyq7DjdRbseYoKdhzuIPJktlWZBSquD+NQGO0N+uWUEF8JxE6bSYqj+Sg5KKoNC0JEBBQc7pnAmwb7NsOfE6p1iz06WVcfgZIQQvIpFG/vqOedtOrY6RVjc9xxpq8gcBLFGbvyybTkGqytf382ovXyKZhVUZ2FqII6j20eRVxnEuc7JRCWHJW+a4BAUACmuVnPLVYk66UOtEfTvNQpZfR49t6AyE8u32AX8r6vVRIVx/sbgDwl4WZ0qbDrGBxS88/wkxgbUJWyPL7jvGzbO38rirRxKYbyBReqPPgnG/k6dilMNkf3f5WbG+frUMdgoZHfLsmxLuQh2EKt+a7WWdZJrhhWzi6ozcUfCdH/QGkHfXiJg8gqWW9cW4EpDaPJoxyTe2UGluDqLN8asSaif3ViALEne+MXN4zjTQ5rvrcF+LKudIFPzyMDfs2jDsVYOPKJrsH3F+6lI0FaWeSV7a3D6GKTDBAU5ypbnYrh7SpTuyFa20Y83+41MaDKZ6+KqoCiVfe/pMVF4J9tLdeWKHOSUMwz2xjAg4tS6H2s9/6+2FSFfbG6zH6T1v2kZw/iAWghoff9O+Wj9/Xp7JwCeZZGGY9TP+AH1AfOHwUaz5QeD3HfdOWO4E4aaNcW+Y4CK7+5IYKy6s0GumfSCqbrjtjXEpgMgovX61nGcD6u7ErXnVK7Iwl1r3Avs32qdxPt7tR0SZgtqfl/p9bHmYC+SgF8HcJcbBsttvXMs2c8OeTNmG1ewfwxyrss2V3r48ePJHfovW9Qdh7TD8Gwy1WeeJ/2+9hlzBouEvLf5gqn3CAU8bvIIepzpjaFjk15pYjezdguYCgYDeIONNxw7yICls8FgPyzan2bJ+1L5sSwyDHIbl+xlknu1eEUOqIHkya4Jg5nWF11ZdRB3S9j0r1cPJ85XMfWG2mzc6hG27OmYwhs7JqQYnk4s3cqhONg7pMEiyDFXGGw0v25+sNlMe2OQDOtStSwyf9GIdaHKID61Ra0E6e+YQO8Oo3apWEtBjxUWNk2Zpt+s1spzVK2jYAhhsNvx8tYIjndTsMZ7/vYwpa9Kj0MkYArmJssavWKk9mCAkQX63fHghKFm/zr1WLJTRMqOYUYN1l4eEax7tqnmlzCYynas74Ouu21tyMSm/7Q9gr5Oyhub53XX2nxcLSkIoPPOh+P41xaKSZvfn2xcdlbv3opKO5+DnSUBE8qLsgT5zeUvXRe0bOe7kx9r//fU/ECnl2HFKjkGm4sT5BpQWp2F7IoATnWqKT3zPPX7EpvOLWc43R3DsCBY8pd+26pcLLXkhynh8MpPI5hMFvo5P8f6fHtWzzmWDo4p8oMnwVii7sTbj021p0Sa+cy08rmGlet5vRMG12wsQkFlEPtNRMucpSKsvqkpX7DoD7tncKRjUqLp+mIgc11SmSFcpjM9Mzgfpj1XVtasejHGalU/3MZ9x0NgymSirebXDUOtGmzEcGd2q6/UVDE4TQyyaJY9kmbEdvKHaxIEilg0CVlmqQiDqd5KO8gf7toszzLRIrjpyzmgYgDNNPd2UJcArUbLf4RQG4vVj5dxi8T7EiY6SbKsGCJbQXPhn8lXprOr5BZhk5ndVPLMZrYKVK8tABW27//pKEYNMWbtOU4smtwkijkbNZMiWQ9ssRfIU5CDkv6qJqeKwcbzncPK6n0DYRZtPHaQc9VNon9y1iy5f+pfsy5ujNseIXP3r2nuNzTli0gW1WJRIZ4Mg8uqs3C3ZFcDZZV0rVRZ9F9sKZSGKekd07m/bKYknrsGy5TOj2VNLPJDLFJ/7HUwNdDhT1Pcshzpd8+xJ7vNKzWVvVF+Ndh4HplnLZJ1qmsS7z5NrS/klSIrthSbTPRg7wxe3aSdr47bjx/8x+0T+ECwb03IZqxP1Y+3yy/whiVUacRIGTtzxzD3lWVl2zqLnUc/0DcGU4TqnqfKTJEsp/mIDeRfyRVCHuiJ4fBeylzpGSW67tPrQ7i8Rt5FQMPuP7dP4s/tVrbuHCGUYa1HFeyLFMlqZYlkg18MdsNQGTt0swwyDPKjgUaNp/roy74cAlVZ9reaNck+HrMFCuQBt6wvRsGSIN7ZOorpiJLAXjvWEXu+vk4VLIUn32uNYsqw2dv4/qrrcjxDlSTgt9uNsWg/fnwqGMyeZZHGvifBuUgXWjHYzQ/UfpcqBtvP988inWLcSzeWoiCxb/i9liHDZnBn4qaNv7g6G7cnmPOHXZN4P1ndYbdgn7GwZ70Ri/E56nusqM7CZze412e1N48my3fs2mnNUvnrT232x9HCxhqP1Ad4QCT8vTDY7Gdaz7f6df7zubPFoIW1IVzZVCBqtE53RFDxmVyc+8OESPpbsT2Z7anLx2XLc3CiY0L8pGQDafBgD23atueDCyozsHyLWvJjPGQVHep8OB7YUoTiSnmnniOi+I4iZapGqsqlPtcce5fLRebHW+XHEfiSpWTHzKLdMNWZbTvFSJ0x2A+2eLFN7R537VwkJkFlObTDYUlTCOPhGI61juPqphAo3kw1WVorJarXem3deQNWy3cMUITrUxL2/HLLaDKSZX1fVM1xz3dDWFBlLp4nP/itHVpttdyCaZbOaCn9vCfj+QxKFeMrD4QmgnkXOLhYak4RFmNFhh8MdvaX5ezYOPhUMdho9q9eW4SK5bn4sCOCnPKgKJulgwR8TaLQbrB7SrQ/XLQ8F8faI+hrj9qS+7KaMNJg404H2um/r+WCtOyGNJdcLsJ0xhhoDxMRsdM9M4Ykv5vr6e5FGDVYBnsKuBJdGsq0lM1aMcs7Rmq8uTeLNg7auyLBzgk4Spbni20qVH812EX1xXbLoC3SihW5uG5NIaYG43h30wXclii0e3/rCAa6NfZqr8jQXx5EbfTCOzJF3dXJrilcXZsrOutQ2WzvL9WUonHeRMDuXJsnqiu1g67d3zqBIyaXKL3521mzfP4cUMtmaRC08Yy+8OGMwX7YnR2DZWbGuQZJryixY5BqWZasLzUVvg91TqBvO5WtmjHMOA9aDJMD8WQihSouNZfGzVKQBaqszTP1qqTrXlp33pQnNs6HqikfeqrIsXfH69ujOJwQcmrehnt/bdn8OaAXvo/XH3mMsYDoJmthYdJYrPU8PxUc7mzbOcukaUeoOgfXSLaKvtc8gMkBrb9Vun68TnR0bWS422KS6d1oe5Po/zVN1+Z/i8vOQjqfNPlX60YTWST3LF1q3obZMtLi4YktpEKDtc1ns8Ng40uyhiW9qzXdY9wMeZK9SeKFbz4vtpI6WQaZH+wWITKef+9Tpci1dB0gAR+S5Inp+bXbShyL7DRz/XtRTakl+c2RK387Pvx5JzM8Q998ljDT/dxU2eE/Rpoqu3PHajM2aYuOCtNvfGqBbfvooU3DwkWiAnfaPnqqPSK65/hl3ZqwKTp1fVMIC+/MFg1LD7ZGEarMwPWWXlhdLSOS/K865rqd7k1OaS6agI2WQvb+UuM25iwdBws/Ydw+quMwe9SYj9QB3W+15VznM831xrmVWVhYF0KoOkto7cnWMVyzvti0AZzI19vNgzaN9qrLrlpbgMWWpmevNg+LZuALa7IEbn/QPiFaCMssAAnpU+tDoA1obsdvW0ZFFsmPH+tmaVSYdOxA+IsnrBvAxxuPNTGOHc4ryy2WLMcwu+tjxPjZYxA1CK/aYu+t0bP5PGIRoLIphKLqLLG7kNwk2nBGJKuyLh+LVuQiFlFAxe7nuidxv6Q5CzUFpz9GVq37mfbxl1dnYoVLeyWq5Pi9aW+wlVjKOYR3XbrFO+Fs1RO7Qq3qEkgc5A9HM3PPKxyZxpVhXynp+GfelSJldQUoXJ6fbGl4oTOKgefHBAM2j0fHINJo6rJjPd5rOY+qjcViE5p20H3ebB7CDWsLhP9rPN5sGcYt3y1EjgVvKW3Yt1eretTmbZ5/YWWGiE1Tm3/ao/SJVXlYIqnDorZK//7DMUyaYtd+skd278R9PzaP8GDBwu+1MtH93NQILVJ/zNCjcm4x2I2dX7VlAbIl7fqphWHfpiFQKyUny1K5thjlBoFRj46T7eOolnXf2TyMWyT9syjYMTmooNrwLQfaT/zGphHTviN9sUMI9aamPJDWaofo4/HLCVw4Hsf1D2ajeElQNGahnpWH9k651GDZs3SpYrD2fjlY0jzbBdzQ90UF/AUtlirfPiHXYDum2Km71TLQ/UvqClBW59wWcHogjkPNZ6URNu1+FIsOVWVirDeGc51RZOQHcNs2u+l+q3kIN28stmnqYbHpLAoKRxZVBRGPAic79bpo3Syrloj83fstW0mNFoG6zR5Kar4RlqwJA7/ehhzOZBgMoHZ9W4h2qyRQ2jAyamUYGSs9yYEFfiImMqLgpGlOrLZy22WunWZpeIdbBjBh6DpnZ+H2xXTt2iIsMGg2dXw/9PQYFq7IxVKDplKcunvTcHITuNv4tbw1pQzdOs2SJv/buhFTNx13Vi+PA/j3NpIcaCC/IHS5YytDepljDUd/BgSaU40lp1tted3Oy11ZJ/2yb/N5jPaoedNUxrVgRR6yygOYGuQ406mFNTkoRUhNSklTT3WqO/xlsWcnrPv0xiKUVdm/AGOcyCubx3DO4O9aK1KMyuEee7djsAu73rberRkp3Yo2hHPO3/aoFBBzkbFLqwbo2CvP0lQ+dZm0haHxZfVtHsKY+DSdxjqtMXKjGUx1XP7y0UYzfd9TJaIZuNvxyuZxnO0x9rH2n2XzZs1mtp2siAmwW9Y/F3rPOC5pQ/Cxxr5f8UTPShH2ShYDOHd+nzcMHozj0LqzWFBXID6MpfXJGuqM4vTzERGm9I5MpRdLz60IYvHybOSWB0QL/zPdM7gQnsEn1xeK7nZux+9EGlHb+Z96LNmt2lJqWTj/9fpdhd4NwWnQF+qP1gRY4E1qCm4WrjUIOewsAAAJp0lEQVRi4uzHyQiaGVPUezHqFruxXMqiVfM8hAVfDiG/2t4Tklg2RbIiYTX4oN0/9brsJIYl77F4Ra70u0nH9k7g9J9m8GmXftEDvTN4JdkqyU/Hd51DGN+3Xwwm3OI8UPOd3fn7rYvO5aMctG+YiY9yOGeZ5FWU7phifJkqplK32fJVhSioyRWNSOmI9E7hzI5R5FG9VZMzy6aIFsWj/WSp/I6L9grfKdlBqL08ikdTrlfWiJQ0nSosx5L+u/z9pYrBrvl4xl58fGcKH+UQZKu+716F4RWr1tn9M7/+sj8MyqwIYspgdq/bUiHaJrkd7zYPiPwwLY5FtXnJ+iwKbtCnZfVd/6rFoWhWeU0OymqyEItwjIXj+FBsF1UrI2s2FIvid6eDzvv31eeFmSYhFy0JIjIQFxWWH+ydTPjOep7ZXROd89kyiyd1XTlS/6wOTW6ksf8lzpX75BhnZXdGouMne6Rfb98aql+/zMc3k0iDKaCgdtixk5/D20dxplONSFGDlmXri0QNlvGgEp/uTRfEp3X+QtJ51irsV5PddXSLpBPK1OYvSw3KWLfUAnFl3+O7ilL/MBYNdrSh70YFeJ8DGfabW6Mv1pWoJQrctzo6s271fks2liHfpRs8jfNAyyCuW18iWgfLDhLeW+sGRded27eUibos2UGx6v9oGcbnJL2j5QLWO8I79dQwCl2+u9FIAM1KIvP3LTs24koGlj3+bOEhJ2vj6+OUDKzZaWeBV5bGrS7Zz8798roCLHT5MCV9z+HEjjFcu95e8WicNCUbIuFYshma0ws5sH0MVz2YK3YYupno366mQr35iCXbLaP2nqyVLhxsW/NsPk5Jj9I+L8vByzXC5Zfdqee7a7qspsro7xKuXr2xzBGHe1uGQO0NL/f4ZCxllAiLKz3OOyryyXHcut6Z2Jk7zrpXRc52/nYcTpYnnYjOxedlaYDDjX2PcQ7RjdaNrc4XBolP5KwqRMlyw9dSwjMIPz2K8fC06Be92JeAYyJV6HaQgGln/+IV2bhZ8iHpYx0TeH+HMYUo32zuFLlyj/i5f2fK+P7jjDc07yya/QeitZcx3ND/ew5+v7pJ2VszZcRhLjAovzpHsGxKQmjjoO8d3rLN/rENoyB7t46IfPDtHp+WJROtfv2bCSJGCX8qlaUqSqqqpC2iftmtG4bKvBNvPz5ZFP/St9uKPu+6UhO/9MRg7SbnVvYtCgZZjwJeYmTV/uql09916B4h0+97xaoCLHpQrp2EvftbhgRmUumsE8miIvguUQTvbKmsFkzfX6wHK9wtndPuTPn1Nn+Z4wyLB2771p4Q9VbxPHwLmO401NBfB+CXfjA43Xymjln+YsTGCNaVEiGP9E6jV3wyVhUNFQFUf7fI9v1gyv9S11n1C6R6zFuHHX9+vBmm0rF0HrF0nnH//9gV2ucp2VQ1WLvhYEPfzwDWbNcs9Qx7lx7zyky1Q4D/LJX6fDLXhSKsyRHpj2MsEca0jqusJlv0kqbRTQ0qOCW+Fuo9fue9RO7zl78v5w52Mu+EscC2b+50/6S7VfApabDQrpUHsoYy8v/EGW5y02R5bNie99TuIcdsa9ZIRmhS+9afX8uinWccnxuH8I69y7epmO9vz5Lpv8ebZbHCz3x1D1M/aerzSFnAdN+BR44t5fHAHwFWlg4GeWd/5JUPfrDRhlniRfiJLDlho/x6+3P8Y3DK82dsKBBX7lqzu/ioT7kmT0tLwHT1YOOxTyo88BIHKzBqcqoYZA9Tzn8+1w+H8D+uOYglJ8Qh7Z7DMBaP475v7S56K1XhqktzFsdgQ//n4hwvcsaCWlDDCYPnAoO8/HB6Rvp9ufxxiLnwY513MNjCujGFK5//5q6SV9MV06wETA892xB+hDY6cck3H9L1A40sVr+HtVwn1QiZUztDucWYLz9eZhmk+WvGFIXjkbVtRYnN+emJeNYCFkJuPP5NhSv/4JZ18vaXnf1APxgqq6nyg3Xe4zJjsJloee/48OvH2yKECv/va3YX/2N6YtWvmhMB0+1ON4ZXcgWtYMhOu6bI1hvSvV44tef4Y9syVu+O2bPvXGDCXgb6psBjq3cW75mtcGeNwdYBnG44sYLz+K85CxR5VxG6s9v5zlJpmmXci+VH450x2IlFq/+uchSvCFlgAJw/9I1dxd1zIdw5F7DQ5Ibwsjjwa4Bda175ZqzT2LZfP9CMxer051uztPtL2a3l+d5+vHz+Bq/jaEDBA4+l4Qq5LYY5M9HGh5xtOLZwGsHdAFbYX477Srd2xXFm53ILINcU9288uHe1MbPrVOqyjcEeD/+8M4bgw3/TFjo7V5qr3WdeBCy0ayXPOBE8sQnAD43VmW7bYfz4p/ZIlFOEyN57w7na0inl59dSGBetfz+ei1PZT3JjRRu+uofRLrs5P+ZNwNpITzx8olYJ8Gc5UOqNQebekO7n29mtHl6ce3br7cebLZMnh+D8DDIyvv7oc0V751yqhhvOu4DpWUdXfnhVMBh7TgHu8e0HunTP8ZOP9qoUsfMDe02ZG4ew/k5uju1eQAIOXovHslZ+zWfKbzYL4KIIWCVEnIUbT35d4fwnFMNOLeLl/a3DVLNUdkx04gZ2DE6dbavj54wNQVFa/npX6TNM3VMw78dFE7A2k5OrTpZNzSj/G2CPKSJU6o6h/jRFlqWyY7DfCFlq/rXbBz+SGky3fHomM/g/H91RSJUHF+246ALWZnak/tTdYMo2BaiRYe3FyFJpz3Vn0bofa65ulLN4mxfA+essmPGt+meLbdtKLoaUPzIBJwXdcOLBOPC3APuMG4um83Wz7s1u7X6pO7tN14918eNf4wp+VL+7dF5JlNci+cgFrA3wUEP4HrCMHygcf2XXKH9+bApZGlOXG2+2blwcnn78bwH246+2lb7m9fIvxu8vGQFrkz3YcOIWzgLf4BwNClCha4ifXXoO+2Z9xLgtOwZsPTCtkTTLuAaAwC4OPPOVttJ3L4bg/D7jkhOwNvBX7uXBhYtOPRAHmsDYFxQgx6hpl0AsOcKBF6Cw1uKzpS9/9lWmfh3rEjsuWQEb39PBrw8UTE1O/yU47uOM3cc5rvbjx2r+8hzGkg+DsX1xhe3LzZzZ+0DrItGq6FI+PhYCtr7At+tPL+FQ7gNj9xEL52DX66zbym7Vq+UxbvdaLQZ2OM7xOgLsZcbYSw89V3byUhambGwfSwHLJvJ6w9lbGPgyAMs4sEwBFnKOPASQTz8VsHyAFyWwdoT2mCscUc5AXxAkTTyrcNbDwA7EuXLgwd0L3/m4CVM23v8Px4l5/WI3HHkAAAAASUVORK5CYII=`;
var downArrowDarkBase64 = `data:image/png;base64,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`;

// src/components/walletEntry/style.ts
var style2 = `
.particle-wallet-entry-container .particle-pwe-btn {
  background: none;
  border: none;
  cursor: pointer;
  height: 60px;
  margin: 0;
  outline: none;
  padding: 0;
  position: fixed;
  width: 60px;
  -webkit-box-shadow: 2px 2px 10px 3px rgba(0, 0, 0, 0.1);
  box-shadow: 2px 2px 10px 3px rgba(0, 0, 0, 0.1);
  border-radius: 60px;
}
.particle-wallet-entry-container .particle-pwe-btn:not(.is-dragging) {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.particle-wallet-entry-container .particle-pwe-btn > img {
  height: 100%;
  width: 100%;
}
.particle-wallet-entry-container .particle-pwe-btn .particle-pwe-wallet-icon {
  display: block;
}
.particle-wallet-entry-container .particle-pwe-btn .particle-pwe-wallet-icon:not(.particle-pwe-wallet-icon-hide) {
  -webkit-animation: particle-pwe-wallet-icon-show 0.3s ease-in-out;
          animation: particle-pwe-wallet-icon-show 0.3s ease-in-out;
}
@-webkit-keyframes particle-pwe-wallet-icon-show {
  0% {
    -webkit-transform: scale(0.6);
            transform: scale(0.6);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}
@keyframes particle-pwe-wallet-icon-show {
  0% {
    -webkit-transform: scale(0.6);
            transform: scale(0.6);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}
.particle-wallet-entry-container .particle-pwe-btn .particle-pwe-wallet-icon.particle-pwe-wallet-icon-hide {
  display: none;
}
.particle-wallet-entry-container .particle-pwe-btn .particle-pwe-down-arrow {
  display: block;
}
.particle-wallet-entry-container .particle-pwe-btn .particle-pwe-down-arrow:not(.particle-pwe-down-arrow-hide) {
  -webkit-animation: particle-pwe-down-arrow-show 0.3s ease-in-out;
          animation: particle-pwe-down-arrow-show 0.3s ease-in-out;
}
@-webkit-keyframes particle-pwe-down-arrow-show {
  0% {
    -webkit-transform: scale(0.6);
            transform: scale(0.6);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}
@keyframes particle-pwe-down-arrow-show {
  0% {
    -webkit-transform: scale(0.6);
            transform: scale(0.6);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}
.particle-wallet-entry-container .particle-pwe-btn .particle-pwe-down-arrow.particle-pwe-down-arrow-hide {
  display: none;
}
.particle-wallet-entry-container .particle-pwe-iframe-content {
  background-color: #fff;
  border: none;
  border-radius: 10px;
  -webkit-box-shadow: -1px 3px 11px 2px #00000073;
          box-shadow: -1px 3px 11px 2px #00000073;
  display: none;
  height: 650px;
  overflow: hidden;
  position: fixed;
  width: 400px;
  z-index: 1000;
}
.particle-wallet-entry-container .particle-pwe-iframe-content.particle-pwe-full-screen-iframe-content {
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  border-radius: 0 !important;
}
@media screen and (max-height: 660px) {
  .particle-wallet-entry-container .particle-pwe-iframe-content {
    height: 600px;
    width: 360px;
  }
}
.particle-wallet-entry-container .particle-pwe-iframe-content.particle-pwe-iframe-content-show {
  display: block;
}
.particle-pwe-iframe-content-dark{
  background-color: #000 !important;
}
.particle-pwe-iframe-content-light{
  background-color: #fff !important;
}
.particle-wallet-entry-container .particle-pwe-iframe-content .particle-pwe-iframe {
  border: none;
  height: 100%;
  width: 100%;
}

`;
var renderStyle = () => {
  const className = "particle-wallet-entry-style";
  const el = document.querySelector("." + className);
  el && el.remove();
  const styleEl = document.createElement("style");
  styleEl.classList.add(className);
  styleEl.innerHTML = style2;
  document.head.appendChild(styleEl);
};
var style_default = renderStyle;

// src/components/walletEntry/index.ts
var fullScreenClass = "particle-pwe-full-screen-iframe-content";
var isListen = false;
var WalletEntryPosition = /* @__PURE__ */ ((WalletEntryPosition2) => {
  WalletEntryPosition2["BR"] = "bottom-right";
  WalletEntryPosition2["BL"] = "bottom-left";
  WalletEntryPosition2["TR"] = "top-right";
  WalletEntryPosition2["TL"] = "top-left";
  return WalletEntryPosition2;
})(WalletEntryPosition || {});
var timer = null;
var draggie;
var _WalletEntryPlugin = class {
  constructor(config, auth, options) {
    this.config = config;
    this.auth = auth;
    this.walletEntryOptions = options;
    if (typeof window !== "undefined") {
      this.destroy();
      if (this.auth.isLogin()) {
        this.walletEntryRander();
      }
      this.auth.on("connect", () => {
        this.walletEntryRander();
      });
      this.auth.on("disconnect", () => {
        this.destroy();
      });
    }
  }
  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  openWallet(params) {
    var _a, _b, _c, _d, _e, _f;
    if (!((_b = (_a = this.auth) == null ? void 0 : _a.isLogin) == null ? void 0 : _b.call(_a))) {
      return;
    }
    const url = getWalletUrl(this.auth);
    if (this.isMobile() || isBraveBrowser()) {
      window.open(url);
      return false;
    }
    const walletIcon = document.querySelector(".particle-pwe-wallet-icon");
    const downArrow = document.querySelector(".particle-pwe-down-arrow");
    const iframeContent = document.querySelector(".particle-pwe-iframe-content");
    if ((params == null ? void 0 : params.windowSize) === "large") {
      iframeContent == null ? void 0 : iframeContent.classList.add(fullScreenClass);
    }
    if (!isNullish((_d = (_c = this.auth) == null ? void 0 : _c.getAuthTheme()) == null ? void 0 : _d.modalBorderRadius)) {
      iframeContent.style.borderRadius = `${(_f = (_e = this.auth) == null ? void 0 : _e.getAuthTheme()) == null ? void 0 : _f.modalBorderRadius}px`;
    }
    iframeContent == null ? void 0 : iframeContent.classList.add("particle-pwe-iframe-content-show");
    const uiMode = getWalletUIMode(this.auth);
    if (uiMode == "dark") {
      iframeContent == null ? void 0 : iframeContent.classList.add("particle-pwe-iframe-content-dark");
      iframeContent == null ? void 0 : iframeContent.classList.remove("particle-pwe-iframe-content-light");
    } else {
      iframeContent == null ? void 0 : iframeContent.classList.add("particle-pwe-iframe-content-light");
      iframeContent == null ? void 0 : iframeContent.classList.remove("particle-pwe-iframe-content-dark");
    }
    let iframe = document.querySelector(".particle-pwe-iframe");
    if ((iframe == null ? void 0 : iframe.src) && new URLSearchParams(iframe == null ? void 0 : iframe.src).get("theme") !== uiMode) {
      iframe.remove();
      iframe = null;
    }
    if (!iframe) {
      iframe = document.createElement("iframe");
      iframe.className = "particle-pwe-iframe";
      iframe.allow = "camera";
      iframeContent == null ? void 0 : iframeContent.appendChild(iframe);
      iframe.src = url;
    }
    walletIcon == null ? void 0 : walletIcon.classList.add("particle-pwe-wallet-icon-hide");
    downArrow == null ? void 0 : downArrow.classList.remove("particle-pwe-down-arrow-hide");
    this.updateIframeContentPosition();
  }
  setWalletIcon() {
    const walletIconEl = document.querySelector(".particle-pwe-wallet-icon");
    const downArrowEl = document.querySelector(".particle-pwe-down-arrow");
    walletIconEl && walletIconEl.setAttribute("src", walletIconDarkBase64);
    downArrowEl && downArrowEl.setAttribute("src", downArrowDarkBase64);
  }
  updateIframeContentPosition() {
    var _a, _b;
    const iframeContent = document.querySelector(".particle-pwe-iframe-content");
    if (!iframeContent || ((_a = iframeContent == null ? void 0 : iframeContent.style) == null ? void 0 : _a.display) === "none") {
      return;
    }
    const walletBtn = document.querySelector(".particle-pwe-btn");
    if (!((_b = this.config.wallet) == null ? void 0 : _b.displayWalletEntry)) {
      walletBtn.style.display = "none";
    }
    const walletBtnRect = walletBtn.getBoundingClientRect();
    const iframeContentRect = iframeContent.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    const iframeContentHeight = iframeContentRect.height;
    const iframeContentWidth = iframeContentRect.width;
    const walletBtnHeight = walletBtnRect.height;
    const walletBtnTop = walletBtnRect.top;
    const walletBtnLeft = walletBtnRect.left;
    const walletBtnBottom = walletBtnRect.bottom;
    const walletBtnRight = walletBtnRect.right;
    if (walletBtnBottom + iframeContentHeight + 10 < windowHeight && walletBtnRight + iframeContentWidth + 10 < windowWidth) {
      iframeContent.style.top = walletBtnBottom + 10 + "px";
      iframeContent.style.left = walletBtnLeft + "px";
    } else if (walletBtnBottom + iframeContentHeight + 10 < windowHeight && walletBtnLeft - iframeContentWidth - 10 > 0) {
      iframeContent.style.top = walletBtnBottom + 10 + "px";
      iframeContent.style.left = walletBtnRight - iframeContentWidth + "px";
    } else if (walletBtnTop - iframeContentHeight - 10 > 0 && walletBtnRight + iframeContentWidth + 10 < windowWidth) {
      iframeContent.style.top = walletBtnTop - iframeContentHeight - 10 + "px";
      iframeContent.style.left = walletBtnLeft + "px";
    } else if (walletBtnTop - iframeContentHeight - 10 > 0 && walletBtnLeft - iframeContentWidth - 10 > 0) {
      iframeContent.style.top = walletBtnTop - iframeContentHeight - 10 + "px";
      iframeContent.style.left = walletBtnRight - iframeContentWidth + "px";
    } else if (walletBtnRight + iframeContentWidth + 10 < windowWidth) {
      const top = walletBtnTop + walletBtnHeight / 2 - iframeContentHeight / 2;
      iframeContent.style.top = top < 30 ? 30 + "px" : top > windowHeight - iframeContentHeight - 30 ? windowHeight - iframeContentHeight - 30 + "px" : top + "px";
      iframeContent.style.left = walletBtnRight + 10 + "px";
    } else if (walletBtnLeft - iframeContentWidth - 10 > 0) {
      const top = walletBtnTop + walletBtnHeight / 2 - iframeContentHeight / 2;
      iframeContent.style.top = top < 30 ? 30 + "px" : top > windowHeight - iframeContentHeight - 30 ? windowHeight - iframeContentHeight - 30 + "px" : top + "px";
      iframeContent.style.left = walletBtnLeft - iframeContentWidth - 10 + "px";
    } else {
    }
  }
  setButtonStorageData(data) {
    const { innerWidth, innerHeight } = window;
    const position = this.walletEntryOptions.position || "bottom-right" /* BR */;
    localStorage.setItem(
      _WalletEntryPlugin.WALLET_BTN_POSITION,
      `${data.x},${data.y},${data.direction},${position}`
    );
    localStorage.setItem(_WalletEntryPlugin.WALLET_BTN_POSITION + "_window", `${innerWidth},${innerHeight}`);
  }
  getButtonStorageData() {
    var _a, _b, _c, _d;
    const { innerWidth, innerHeight } = window;
    const [x, y, direction = "right", position] = ((_b = (_a = localStorage == null ? void 0 : localStorage.getItem(_WalletEntryPlugin.WALLET_BTN_POSITION)) == null ? void 0 : _a.split) == null ? void 0 : _b.call(_a, ",")) || [];
    let [width, height] = ((_d = (_c = localStorage.getItem(_WalletEntryPlugin.WALLET_BTN_POSITION + "_window")) == null ? void 0 : _c.split) == null ? void 0 : _d.call(_c, ",")) || [];
    width = Number(width || 0);
    height = Number(height || 0);
    if (width && height && (width != innerWidth || height != innerHeight)) {
      localStorage.removeItem(_WalletEntryPlugin.WALLET_BTN_POSITION);
      localStorage.removeItem(_WalletEntryPlugin.WALLET_BTN_POSITION + "_window");
      return {
        x: innerWidth,
        y: innerHeight,
        position: position || this.walletEntryOptions.position || "bottom-right" /* BR */,
        direction: "right"
      };
    }
    return {
      x: Number(x) || 0,
      y: Number(y) || 0,
      position: position || this.walletEntryOptions.position || "bottom-right" /* BR */,
      direction
    };
  }
  updateWalletBtnPosition(x, y, type2 = "") {
    const { width } = document.body.getBoundingClientRect();
    const { direction } = this.getButtonStorageData();
    const isRight = x > width / 2 || type2 == "windowResize" && direction === "right";
    let left = isRight ? width - 60 : 0;
    let top = y;
    let newDirection = "left";
    if (left < 30) {
      left = 30;
      newDirection = "left";
    } else if (left > width - 90) {
      left = width - 90;
      newDirection = "right";
    }
    if (top < 30) {
      top = 30;
    } else if (top > window.innerHeight - 90) {
      top = window.innerHeight - 90;
    }
    return {
      left,
      top,
      direction: newDirection
    };
  }
  closeWallet() {
    const iframeContent = document.querySelector(".particle-pwe-iframe-content");
    iframeContent == null ? void 0 : iframeContent.classList.remove("particle-pwe-iframe-content-show");
    const walletIcon = document.querySelector(".particle-pwe-wallet-icon");
    const downArrow = document.querySelector(".particle-pwe-down-arrow");
    walletIcon == null ? void 0 : walletIcon.classList.remove("particle-pwe-wallet-icon-hide");
    downArrow == null ? void 0 : downArrow.classList.add("particle-pwe-down-arrow-hide");
  }
  resize() {
    const that = this;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        localStorage.removeItem(_WalletEntryPlugin.WALLET_BTN_POSITION);
        const walletBtn = document.querySelector(".particle-pwe-btn");
        const { x: btnX, y: btnY } = this.getButtonStorageData();
        const x = btnX || window.innerWidth;
        const y = btnY || window.innerHeight;
        const { left, top, direction } = that.updateWalletBtnPosition(x, y, "windowResize");
        if (walletBtn) {
          walletBtn.style.left = left + "px";
          walletBtn.style.top = top + "px";
        }
        this.setButtonStorageData({
          x,
          y,
          direction
        });
        that.updateIframeContentPosition();
        (() => __async(this, null, function* () {
          let count = 0;
          do {
            count++;
            yield this.sleep(100);
            this.updateIframeContentPosition();
          } while (count < 15);
        }))();
      }, 10);
    };
  }
  sleep(ms) {
    return __async(this, null, function* () {
      return new Promise((resolve) => setTimeout(resolve, ms));
    });
  }
  preload() {
    const url = walletUrl();
    const script = document.createElement("script");
    script.src = `${url}/preload.js?_=${Math.floor(Date.now() / 6e4) * 6e4}`;
    script.setAttribute("data-target", "web-wallet");
    document.body.appendChild(script);
  }
  walletEntryRander() {
    return __async(this, null, function* () {
      var _a;
      style_default();
      html_default();
      this.setWalletIcon();
      if (((_a = this.walletEntryOptions) == null ? void 0 : _a.preload) !== false) {
        this.preload();
      }
      const walletBtn = document.querySelector(".particle-pwe-btn");
      const { x: btnX, y: btnY } = this.getButtonStorageData();
      if (btnX && btnY) {
        if ((Number(btnX) || 0) < window.innerWidth && (Number(btnY) || 0) < window.innerHeight) {
          const { left, top } = this.updateWalletBtnPosition(Number(btnX) || 0, Number(btnY) || 0);
          walletBtn.style.left = left + "px";
          walletBtn.style.top = top + "px";
          this.updateIframeContentPosition();
        } else {
          const { left, top } = this.updateWalletBtnPosition(window.innerWidth, window.innerHeight);
          walletBtn.style.left = left + "px";
          walletBtn.style.top = top + "px";
          this.updateIframeContentPosition();
        }
      } else {
        const position = this.walletEntryOptions.position || "bottom-left" /* BL */;
        let top, left;
        if (position === "bottom-right" /* BR */) {
          top = window.innerHeight;
          left = window.innerWidth;
        } else if (position === "top-right" /* TR */) {
          top = 0;
          left = window.innerWidth;
        } else if (position === "top-left" /* TL */) {
          top = 0;
          left = 0;
        } else {
          top = window.innerHeight;
          left = 0;
        }
        const positionData = this.updateWalletBtnPosition(left, top);
        walletBtn.style.left = positionData.left + "px";
        walletBtn.style.top = positionData.top + "px";
        this.updateIframeContentPosition();
      }
      const walletIcon = document.querySelector(".particle-pwe-wallet-icon");
      const downArrow = document.querySelector(".particle-pwe-down-arrow");
      let isDraggie = false;
      const Draggabilly = (yield import("draggabilly")).default;
      draggie = new Draggabilly(walletBtn);
      draggie.on("dragStart", () => {
        isDraggie = true;
        walletBtn.style.cursor = "move";
      });
      draggie.on("dragMove", () => {
        this.updateIframeContentPosition();
      });
      draggie.on("dragEnd", (event, pointer) => {
        event.stopPropagation();
        walletBtn.style.cursor = "pointer";
        const { clientX: x, clientY: y } = pointer;
        const { left, top, direction } = this.updateWalletBtnPosition(x, y - 35);
        walletBtn.style.left = left + "px";
        walletBtn.style.top = top + "px";
        this.updateIframeContentPosition();
        (() => __async(this, null, function* () {
          let count = 0;
          do {
            count++;
            yield this.sleep(20);
            this.updateIframeContentPosition();
          } while (count < 70);
        }))();
        this.setButtonStorageData({
          x: left,
          y: top,
          direction
        });
        setTimeout(() => {
          isDraggie = false;
        });
      });
      walletBtn.addEventListener("touchend", () => {
        if (!isDraggie) {
          this.openWallet();
        }
      });
      walletIcon == null ? void 0 : walletIcon.addEventListener("click", (event) => {
        var _a2;
        (_a2 = event == null ? void 0 : event.stopPropagation) == null ? void 0 : _a2.call(event);
        if (!isDraggie && !this.isMobile()) {
          this.openWallet();
        }
      });
      downArrow == null ? void 0 : downArrow.addEventListener("click", (e) => {
        e.stopPropagation();
        if (!isDraggie) {
          this.closeWallet();
        }
      });
      window.walletEntryPlugin = this;
      if (!isListen) {
        isListen = true;
        window.addEventListener("resize", window.walletEntryPlugin.resize(), false);
        window.addEventListener(
          "message",
          (events) => {
            var _a2, _b, _c, _d, _e;
            if (((_a2 = events == null ? void 0 : events.data) == null ? void 0 : _a2.type) === "PARTICLE_WALLET_RESIZE_IFRAME") {
              const iframeContent = document.querySelector(".particle-pwe-iframe-content");
              const classList = iframeContent == null ? void 0 : iframeContent.classList;
              if ((_b = classList == null ? void 0 : classList.contains) == null ? void 0 : _b.call(classList, fullScreenClass)) {
                if (!((_c = window.walletEntryPlugin.config.wallet) == null ? void 0 : _c.displayWalletEntry)) {
                  window.walletEntryPlugin.closeWallet();
                } else {
                  (_d = classList == null ? void 0 : classList.remove) == null ? void 0 : _d.call(classList, fullScreenClass);
                  window.walletEntryPlugin.resize();
                  window.walletEntryPlugin.updateIframeContentPosition();
                }
              } else {
                (_e = classList == null ? void 0 : classList.add) == null ? void 0 : _e.call(classList, fullScreenClass);
              }
            }
          },
          false
        );
      }
    });
  }
  destroy() {
    var _a, _b, _c;
    (_a = draggie == null ? void 0 : draggie.destroy) == null ? void 0 : _a.call(draggie);
    window.removeEventListener("resize", this.resize(), false);
    (_c = (_b = document.querySelector(".particle-wallet-entry-container")) == null ? void 0 : _b.remove) == null ? void 0 : _c.call(_b);
  }
};
var WalletEntryPlugin = _WalletEntryPlugin;
WalletEntryPlugin.WALLET_BTN_POSITION = "walletBtnPosition";

// src/utils/active.ts
import { AcitveLoginType } from "@particle-network/analytics";
function particleActive(bi, chainId, walletAddress, userInfo, action) {
  const _a = userInfo, { token, thirdparty_user_info, security_account } = _a, user = __objRest(_a, ["token", "thirdparty_user_info", "security_account"]);
  bi.active({
    chain_id: chainId,
    identity: user.uuid,
    login_type: AcitveLoginType.PARTICLE,
    action,
    wallet_address: walletAddress,
    user_info: JSON.stringify(user, (key, value) => {
      if (!isNullish(value))
        return value;
    })
  });
}

// src/utils/create-session.ts
var createSession = (data) => __async(void 0, null, function* () {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${apiUrl()}/auth-sessions`, true);
    xhr.timeout = 3e4;
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.onload = function() {
      const response = JSON.parse(this.responseText);
      if (response.error_code) {
        reject(response.message);
      } else {
        resolve(response.key);
      }
    };
    xhr.onerror = function() {
      reject(this.statusText);
    };
    xhr.send(`data=${data}`);
  });
});
var create_session_default = createSession;

// src/utils/silence-logout.ts
var silenceLogout = (_0) => __async(void 0, [_0], function* ({
  token,
  projectUuid,
  projectKey
}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    let url = `${apiUrl()}/fast_logout`;
    url += `?projectUuid=${projectUuid}&projectKey=${projectKey}`;
    xhr.open("POST", url, true);
    xhr.timeout = 3e4;
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.onload = function() {
      const response = JSON.parse(this.responseText);
      if (response.error_code) {
        reject(response);
      } else {
        resolve(response.success);
      }
    };
    xhr.onerror = function() {
      reject(this.statusText);
    };
    xhr.send(`token=${token}`);
  });
});
var silence_logout_default = silenceLogout;

// src/utils/user-simple-info.ts
var userSimpleInfo = (_0) => __async(void 0, [_0], function* ({
  token,
  projectUuid,
  projectKey,
  projectAppUuid
}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    let url = `${apiUrl()}/apps/${projectAppUuid}/user-simple-info`;
    url += `?projectUuid=${projectUuid}&projectKey=${projectKey}&token=${token}`;
    xhr.open("GET", url, true);
    xhr.timeout = 3e4;
    xhr.onload = function() {
      const response = JSON.parse(this.responseText);
      if (response.error_code) {
        reject(response);
      } else {
        resolve(response);
      }
    };
    xhr.onerror = function() {
      reject(this.statusText);
    };
    xhr.send();
  });
});
var user_simple_info_default = userSimpleInfo;

// src/auth.ts
var Auth = class {
  constructor(config, bi) {
    this.config = config;
    this.bi = bi;
    this.PN_AUTH_USER_INFO = "pn_auth_user_info";
    this.PN_AUTH_TYPE = "pn_auth_type";
    this.PN_TEMP_SECRET_KEY = "pn_temp_secret_key";
    this.events = new EventEmitter();
    this.uiMode = "auto";
    this.displayCloseButton = true;
    this.displayWallet = false;
    this.modalBorderRadius = 24;
    this.authResultMap = /* @__PURE__ */ new Map();
    if (typeof window !== "undefined") {
      addEventListener("message", (event) => {
        var _a, _b, _c;
        if (((_a = event == null ? void 0 : event.data) == null ? void 0 : _a.name) === "particle-network-provider") {
          this.handleAuthEvent(event);
        } else if (((_b = event == null ? void 0 : event.data) == null ? void 0 : _b.name) === "particle-network-wallet") {
          this.handleWalletEvent(event);
        } else if (((_c = event == null ? void 0 : event.data) == null ? void 0 : _c.name) === "particle-network-auth-load-completed") {
          this.hideIframeBackground(event);
        }
      });
    }
  }
  handleAuthEvent(event) {
    var _b, _d;
    const authResult = this.getAuthResult((_b = event.data) == null ? void 0 : _b.state, true);
    if (!authResult) {
      return;
    }
    let data;
    try {
      data = this.decrypt(event.data);
    } catch (error) {
      data = {
        error: AuthError.decrypt(error)
      };
    }
    if (data.wallets) {
      const userInfo = this.getUserInfo();
      if (userInfo) {
        userInfo.wallets = data.wallets;
        this.setUserInfo(userInfo);
      }
    }
    if (data.security_account) {
      const userInfo = this.getUserInfo();
      if (userInfo) {
        userInfo.security_account = data.security_account;
        this.setUserInfo(userInfo);
      }
    }
    if (data.token && data.uuid) {
      const _c = data, { redirect_type } = _c, info = __objRest(_c, ["redirect_type"]);
      this.setUserInfo(info);
      this.setAuthType(((_d = event.data) == null ? void 0 : _d.authType) || "");
      this.bi.records({
        record_type: RecordType.PAGE_LOGIN_SUCCESS_BACK
      });
    }
    const { resolve, reject, container } = authResult;
    if (data.error) {
      if (data.error.code === 8005 || data.error.code === 10005) {
        this.setUserInfo(null);
        this.events.emit("disconnect");
      }
      reject(data.error);
    } else {
      resolve(data);
    }
    if (container) {
      try {
        if ("remove" in container) {
          container.remove();
        }
      } catch (e) {
      }
    }
    const containerDiv = document.getElementById("particle-network-container");
    if (containerDiv) {
      containerDiv.style.display = "none";
    }
  }
  handleWalletEvent(event) {
    var _a, _b;
    const type2 = (_b = (_a = event == null ? void 0 : event.data) == null ? void 0 : _a.data) == null ? void 0 : _b.type;
    if (type2 === "logout") {
      this.setUserInfo(null);
      this.events.emit("disconnect");
    }
  }
  hideIframeBackground(event) {
    var _a;
    const state = (_a = event == null ? void 0 : event.data) == null ? void 0 : _a.state;
    const result = this.authResultMap.get(state);
    if (result && result.container && "remove" in result.container) {
      result.container.style.backgroundColor = "#00000000";
    }
  }
  setAuthResult(authResult) {
    if ((authResult == null ? void 0 : authResult.container) && "close" in authResult.container && !authResult.container.closed) {
      try {
        authResult.intervalTimer = setInterval(() => {
          if ((authResult == null ? void 0 : authResult.container) && "close" in authResult.container && authResult.container.closed) {
            const result = this.getAuthResult(authResult.state, true);
            if (result) {
              result.reject(AuthError.userCancelOperation());
            }
          }
        }, 500);
      } catch (e) {
      }
    }
    this.authResultMap.set(authResult.state, authResult);
  }
  getAuthResult(state, popup = false) {
    if (!state) {
      return void 0;
    }
    const result = this.authResultMap.get(state);
    if (popup && result) {
      if (result.intervalTimer) {
        clearInterval(result.intervalTimer);
        result.intervalTimer = void 0;
      }
      this.authResultMap.delete(state);
    }
    return result;
  }
  login(config) {
    return __async(this, null, function* () {
      var _a;
      this.bi.records({
        record_type: RecordType.PAGE_LOGIN_BUTTON_CLICK
      });
      const url = yield this.buildUrl("/login", {
        login_type: config == null ? void 0 : config.preferredAuthType,
        support_auth_types: (_a = config == null ? void 0 : config.supportAuthTypes) != null ? _a : "all",
        account: config == null ? void 0 : config.account,
        prompt: config == null ? void 0 : config.socialLoginPrompt,
        authorization: config == null ? void 0 : config.authorization
      });
      const state = new URL(url).searchParams.get("state") || "";
      let container;
      if (config && config.preferredAuthType && (this.isSocialLogin(config.preferredAuthType) || config.account && isBlockingThirdpartyCookiesBrowser(
        config.preferredAuthType === "email" || config.preferredAuthType === "phone" || config.preferredAuthType === "jwt"
      ))) {
        const iframeWidth = config.preferredAuthType == "facebook" ? 800 : 475;
        const iframeHeight = 770;
        container = yield this.openUrl(url, iframeWidth, iframeHeight, true, "login");
      } else {
        container = this.getIframe();
        container.src = url;
        if ((config == null ? void 0 : config.preferredAuthType) === "jwt" && (config == null ? void 0 : config.hideLoading)) {
          this.hideLoading(container);
        }
      }
      return new Promise((resolve, reject) => {
        this.setAuthResult({
          resolve: (value) => {
            var _a2;
            this.events.emit("connect", value);
            particleActive(
              this.bi,
              this.getChainId(),
              ((_a2 = this.getWallet()) == null ? void 0 : _a2.public_address) || "",
              this.getUserInfo(),
              ActiveAction2.LOGIN
            );
            resolve(value);
          },
          reject,
          state,
          container
        });
      });
    });
  }
  isSocialLogin(authType) {
    return authType !== "email" && authType !== "phone" && authType !== "jwt";
  }
  logout(hideLoading = true) {
    return __async(this, null, function* () {
      var _a;
      if (!this.isLogin()) {
        return;
      }
      if (hideLoading) {
        try {
          yield silence_logout_default({
            token: ((_a = this.getUserInfo()) == null ? void 0 : _a.token) || "",
            projectUuid: this.config.projectId,
            projectKey: this.config.clientKey
          });
        } catch (error) {
          if ((error == null ? void 0 : error.error_code) !== 10005) {
            throw error;
          }
        }
        this.setUserInfo(null);
        this.events.emit("disconnect");
      } else {
        const url = yield this.buildUrl("/logout");
        const container = yield this.openUrl(url);
        const state = new URL(url).searchParams.get("state") || "";
        if (hideLoading) {
          this.hideLoading(container);
        }
        return new Promise((resolve) => {
          this.setAuthResult({
            resolve: () => {
              this.setUserInfo(null);
              this.events.emit("disconnect");
              resolve();
            },
            reject: (error) => {
              this.setUserInfo(null);
              this.events.emit("disconnect");
              resolve();
            },
            state,
            container
          });
        });
      }
    });
  }
  accountSecurity() {
    return __async(this, null, function* () {
      yield this.openAccountAndSecurity();
    });
  }
  openAccountAndSecurity() {
    return __async(this, null, function* () {
      var _a;
      if (!this.isLogin()) {
        return Promise.reject(AuthError.notLogin());
      }
      const url = yield this.buildUrl("/account/security", { token: (_a = this.getUserInfo()) == null ? void 0 : _a.token });
      const container = yield this.openUrl(url);
      const state = new URL(url).searchParams.get("state") || "";
      return new Promise((resolve, reject) => {
        this.setAuthResult({
          resolve,
          reject,
          state,
          container
        });
      });
    });
  }
  getSecurityAccount() {
    return __async(this, null, function* () {
      var _a;
      if (!this.isLogin()) {
        return Promise.reject(AuthError.notLogin());
      }
      const { projectId, clientKey, appId } = this.config;
      const info = yield user_simple_info_default({
        projectUuid: projectId,
        projectKey: clientKey,
        projectAppUuid: appId,
        token: ((_a = this.getUserInfo()) == null ? void 0 : _a.token) || ""
      });
      const userInfo = this.getUserInfo();
      if (userInfo) {
        this.setUserInfo(__spreadValues(__spreadValues({}, userInfo), info));
      }
      return info;
    });
  }
  hasMasterPassword() {
    var _a, _b;
    if (!this.isLogin()) {
      throw AuthError.notLogin();
    }
    return ((_b = (_a = this.getUserInfo()) == null ? void 0 : _a.security_account) == null ? void 0 : _b.has_set_master_password) || false;
  }
  hasPaymentPassword() {
    var _a, _b;
    if (!this.isLogin()) {
      throw AuthError.notLogin();
    }
    return ((_b = (_a = this.getUserInfo()) == null ? void 0 : _a.security_account) == null ? void 0 : _b.has_set_payment_password) || false;
  }
  hasSecurityAccount() {
    var _a, _b, _c, _d;
    if (!this.isLogin()) {
      throw AuthError.notLogin();
    }
    return !isNullish((_b = (_a = this.getUserInfo()) == null ? void 0 : _a.security_account) == null ? void 0 : _b.phone) || !isNullish((_d = (_c = this.getUserInfo()) == null ? void 0 : _c.security_account) == null ? void 0 : _d.email);
  }
  sign(method, message) {
    return __async(this, null, function* () {
      var _a, _b, _c;
      if (!this.walletExist()) {
        return Promise.reject(AuthError.walletNotCreated());
      }
      let url;
      if (((_a = this.config.chainName) == null ? void 0 : _a.toLowerCase()) === "solana") {
        url = yield this.buildUrl("/solana/sign", {
          token: (_b = this.getUserInfo()) == null ? void 0 : _b.token,
          method,
          message
        });
      } else {
        url = yield this.buildUrl("/evm-chain/sign", {
          token: (_c = this.getUserInfo()) == null ? void 0 : _c.token,
          method,
          message
        });
      }
      const container = yield this.openUrl(url);
      const state = new URL(url).searchParams.get("state") || "";
      return new Promise((resolve, reject) => {
        this.setAuthResult({
          resolve: (value) => {
            var _a2, _b2;
            particleActive(
              this.bi,
              this.getChainId(),
              ((_a2 = this.getWallet()) == null ? void 0 : _a2.public_address) || "",
              this.getUserInfo(),
              ActiveAction2.SIGN
            );
            resolve((_b2 = value.signature) != null ? _b2 : "");
          },
          reject,
          state,
          container
        });
      });
    });
  }
  signAllTransactions(messages) {
    return __async(this, null, function* () {
      var _a;
      if (!this.walletExist()) {
        return Promise.reject(AuthError.walletNotCreated());
      }
      if (((_a = this.config.chainName) == null ? void 0 : _a.toLowerCase()) !== "solana") {
        return Promise.reject(AuthError.unsupportedMethod());
      }
      const result = yield this.sign("signAllTransactions", JSON.stringify(messages));
      const signatures = JSON.parse(result);
      return signatures;
    });
  }
  sendTransaction(message) {
    return __async(this, null, function* () {
      var _a;
      if (!this.walletExist()) {
        return Promise.reject(AuthError.walletNotCreated());
      }
      if (((_a = this.config.chainName) == null ? void 0 : _a.toLowerCase()) === "solana") {
        return this.sign("signAndSendTransaction", message);
      } else {
        return this.sign("eth_sendTransaction", message);
      }
    });
  }
  switchChain(chain, hideLoading = false) {
    return __async(this, null, function* () {
      var _a;
      const userInfo = this.getUserInfo();
      if (!userInfo) {
        return Promise.reject(AuthError.notLogin());
      }
      if (typeof chain.name !== "string" || typeof chain.id !== "number") {
        throw AuthError.paramsError();
      }
      const chainInfo = chains.getChainInfo(chain);
      if (!chainInfo) {
        throw AuthError.unsupportedChain();
      }
      const wallets = userInfo.wallets;
      if (((_a = this.config.chainName) == null ? void 0 : _a.toLowerCase()) === chain.name.toLowerCase() && this.config.chainId === chain.id) {
        return wallets;
      }
      const wallet = this.getWallet(chain.name.toLowerCase() === "solana" ? "solana" : "evm_chain");
      if (wallet) {
        this.config.chainName = chain.name;
        this.config.chainId = chain.id;
        this.events.emit("chainChanged", chain);
        return wallets;
      }
      const result = yield this.createWallet(chain.name, hideLoading);
      this.config.chainName = chain.name;
      this.config.chainId = chain.id;
      this.events.emit("connect", this.getUserInfo());
      this.events.emit("chainChanged", chain);
      return result;
    });
  }
  setChainInfo(chain) {
    if (typeof chain.name !== "string" || typeof chain.id !== "number") {
      throw AuthError.paramsError();
    }
    const chainInfo = chains.getChainInfo(chain);
    if (!chainInfo) {
      throw AuthError.unsupportedChain();
    }
    this.config.chainName = chain.name;
    this.config.chainId = chain.id;
  }
  createWallet(name2, hideLoading = false) {
    return __async(this, null, function* () {
      const userInfo = this.getUserInfo();
      if (!userInfo) {
        return Promise.reject(AuthError.notLogin());
      }
      const wallet = this.getWallet(name2.toLowerCase() === "solana" ? "solana" : "evm_chain");
      if (wallet) {
        return userInfo.wallets;
      }
      const url = yield this.buildUrl("/wallet", {
        token: userInfo.token,
        chain_name: name2
      });
      const state = new URL(url).searchParams.get("state") || "";
      const container = yield this.openUrl(url);
      if (hideLoading) {
        this.hideLoading(container);
      }
      return new Promise((resolve, reject) => {
        this.setAuthResult({
          resolve: (value) => {
            resolve(value);
          },
          reject,
          state,
          container
        });
      });
    });
  }
  hideLoading(container) {
    const containerDiv = document.getElementById("particle-network-container");
    if (containerDiv) {
      containerDiv.style.display = "none";
    }
    try {
      if (container && "remove" in container) {
        container.style.display = "none";
      }
    } catch (e) {
    }
  }
  chainId() {
    return this.getChainId();
  }
  getChainId() {
    return this.config.chainId;
  }
  chain() {
    return this.getChain();
  }
  getChain() {
    return {
      id: this.config.chainId,
      name: this.config.chainName
    };
  }
  basicCredentials() {
    return `Basic ${Buffer4.from(`${this.config.projectId}:${this.config.clientKey}`, "utf8").toString("base64")}`;
  }
  isLogin() {
    return this.getUserInfo() !== null;
  }
  isLoginAsync() {
    return __async(this, null, function* () {
      yield this.getSecurityAccount();
      return this.getUserInfo();
    });
  }
  userInfo() {
    return this.getUserInfo();
  }
  getUserInfo() {
    const info = localStorage.getItem(this.concatStorageKey(this.PN_AUTH_USER_INFO));
    return info ? JSON.parse(info) : null;
  }
  getAuthType() {
    const authType = localStorage.getItem(this.concatStorageKey(this.PN_AUTH_TYPE));
    return authType;
  }
  setAuthType(authType) {
    localStorage.setItem(this.concatStorageKey(this.PN_AUTH_TYPE), authType);
  }
  walletExist() {
    return this.getWallet() != null;
  }
  wallet(chainType) {
    return this.getWallet(chainType);
  }
  getWallet(chainType) {
    const userInfo = this.getUserInfo();
    if (!userInfo) {
      return null;
    }
    const wallet = userInfo.wallets.find((wallet2) => wallet2.chain_name === (chainType || this.walletChainName()));
    if (wallet !== void 0 && wallet.public_address.length > 0) {
      return wallet;
    }
    return null;
  }
  getEVMAddress() {
    const wallet = this.getWallet("evm_chain");
    return Promise.resolve(wallet == null ? void 0 : wallet.public_address);
  }
  getSolanaAddress() {
    const wallet = this.getWallet("solana");
    return Promise.resolve(wallet == null ? void 0 : wallet.public_address);
  }
  setAuthTheme(config) {
    if (config.uiMode) {
      this.uiMode = config.uiMode;
    }
    if (config.displayCloseButton !== null && config.displayCloseButton !== void 0) {
      this.displayCloseButton = config.displayCloseButton;
    }
    if (config.displayWallet !== null && config.displayWallet !== void 0) {
      this.displayWallet = config.displayWallet;
    }
    if (!isNullish(config.modalBorderRadius)) {
      this.modalBorderRadius = config.modalBorderRadius;
    }
  }
  getAuthTheme() {
    return {
      uiMode: this.uiMode,
      displayCloseButton: this.displayCloseButton,
      displayWallet: this.displayWallet,
      modalBorderRadius: this.modalBorderRadius
    };
  }
  on(event, listener) {
    this.events.on(event, listener);
    return this;
  }
  once(event, listener) {
    this.events.once(event, listener);
    return this;
  }
  off(event, listener) {
    this.events.off(event, listener);
    return this;
  }
  removeListener(event, listener) {
    this.events.removeListener(event, listener);
    return this;
  }
  walletChainName() {
    var _a;
    return ((_a = this.config.chainName) == null ? void 0 : _a.toLowerCase()) === "solana" ? "solana" : "evm_chain";
  }
  setUserInfo(info) {
    if (info) {
      localStorage.setItem(this.concatStorageKey(this.PN_AUTH_USER_INFO), JSON.stringify(info));
    } else {
      localStorage.removeItem(this.concatStorageKey(this.PN_AUTH_USER_INFO));
      localStorage.removeItem(WalletEntryPlugin.WALLET_BTN_POSITION);
      localStorage.removeItem(this.concatStorageKey(this.PN_AUTH_TYPE));
    }
  }
  concatStorageKey(key) {
    return `${key}_${this.config.appId}`;
  }
  getIframe() {
    let containerDiv = document.getElementById("particle-network-container");
    if (!containerDiv) {
      containerDiv = document.createElement("div");
      containerDiv.setAttribute(
        "style",
        "display: block;position: fixed;top: 0px;right: 0px;width: 100%;height: 100%;border-radius: 0px;border: none;z-index: 2147483647;background-color: rgba(0, 0, 0, 0.5);align-items: center;"
      );
      containerDiv.id = "particle-network-container";
      document.body.appendChild(containerDiv);
    } else {
      containerDiv.style.display = "block";
    }
    let iframe;
    const elements = document.getElementsByName("particle-network-iframe");
    if (elements.length > 0) {
      iframe = elements[0];
      iframe.style.display = "";
    } else {
      iframe = document.createElement("iframe");
      iframe.name = "particle-network-iframe";
      iframe.className = "particle-auth-iframe";
      iframe.allow = "publickey-credentials-get";
      let bgColor = "#FFFFFF";
      const themeType = this.getThemeType();
      if (themeType === "dark") {
        bgColor = "#1C1D22";
      }
      const { width: screenWidth } = window.screen;
      let width = "400px";
      let height = "650px";
      let top = "50%";
      let left = "50%";
      let borderRadius = this.modalBorderRadius;
      let transform = "translate(-50%, -50%)";
      if (screenWidth < 500) {
        width = "100%";
        height = "100%";
        borderRadius = 0;
        transform = "none";
        top = "0px";
        left = "0px";
      }
      const iframeStyles = {
        position: "absolute",
        left,
        top,
        transform,
        width,
        height,
        border: "none",
        "border-radius": `${borderRadius}px`,
        "z-index": "2147483647",
        "background-color": bgColor
      };
      iframe.setAttribute(
        "style",
        Object.entries(iframeStyles).map(([key, value]) => `${key}:${value}`).join(";")
      );
      containerDiv.appendChild(iframe);
    }
    return iframe;
  }
  openUrl(url, width = 475, height = 770, forcePopup = false, contentKey = "sign") {
    return __async(this, null, function* () {
      const authType = this.getAuthType();
      if (forcePopup || isBlockingThirdpartyCookiesBrowser(authType === "email" || authType === "phone" || authType === "jwt")) {
        let container = popupWindow(url, "particle-auth", width, height);
        if (!container) {
          container = yield this.continuePopup(url, width, height, contentKey);
        }
        container.name = "particle-auth-popup";
        return container;
      }
      const iframe = this.getIframe();
      iframe.src = url;
      return iframe;
    });
  }
  continuePopup(url, width = 500, height = 750, contentKey = "sign") {
    return __async(this, null, function* () {
      return new Promise((resolve, reject) => {
        approvePopupRender(() => {
          const popup = popupWindow(url, "particle-auth", width, height);
          if (popup) {
            resolve(popup);
          } else {
            reject(new Error("popup window blocked"));
          }
        }, contentKey);
      });
    });
  }
  buildUrl(_0) {
    return __async(this, arguments, function* (path, extraParams = {}) {
      const params = {
        project_uuid: this.config.projectId,
        project_client_key: this.config.clientKey,
        project_app_uuid: this.config.appId,
        chain_name: this.config.chainName,
        chain_id: Number(this.config.chainId),
        sdk_version: getVersion(),
        device_id: getDeviceId()
      };
      Object.assign(params, __spreadValues({}, extraParams));
      const state = uuidv42();
      let value = urlCrypto2.encryptUrlParam(params);
      const secretKey = value.slice(-32);
      sessionStorage.setItem(`${this.PN_TEMP_SECRET_KEY}-${state}`, secretKey);
      if (value.length > 1e4) {
        const sessionKey = yield create_session_default(value);
        value = `session_key_${sessionKey}`;
      }
      let url = `${authUrl()}?params=${value}&encoding=base64&theme_type=${this.getThemeType()}&display_close_button=${this.displayCloseButton}&display_wallet=${this.displayWallet}&language=${controller.languageCode}&state=${state}&fiat_coin=${controller.fiatCoin}`;
      if (this.config.securityAccount) {
        url += `&security_account=${encodeURIComponent(JSON.stringify(this.config.securityAccount))}`;
      }
      if (controller.erc4337) {
        url += `&erc4337=${encodeURIComponent(JSON.stringify(controller.erc4337))}`;
      }
      return `${url}#${path}`;
    });
  }
  getThemeType() {
    return this.uiMode === "auto" ? window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : this.uiMode;
  }
  decrypt({ data, state }) {
    const secretKey = sessionStorage.getItem(`${this.PN_TEMP_SECRET_KEY}-${state}`) || "";
    const plaintext = urlCrypto2.decryptData(data, secretKey, "hex");
    return JSON.parse(plaintext);
  }
};

// src/service/evmService.ts
import { Buffer as Buffer5 } from "buffer";

// src/utils/hex-utils.ts
function bufferToHex(buf) {
  return `0x${buf.toString("hex")}`;
}
function intToHex(value) {
  return `0x${Number(value).toString(16)}`;
}
function isHexPrefixed(str) {
  if (typeof str !== "string") {
    throw new Error(`[isHexPrefixed] input must be type 'string', received type ${typeof str}`);
  }
  return str[0] === "0" && str[1] === "x";
}
function addHexPrefix(str) {
  if (typeof str !== "string") {
    return str;
  }
  return isHexPrefixed(str) ? str : "0x" + str;
}
function stripHexPrefix(str) {
  if (typeof str !== "string")
    throw new Error(`[stripHexPrefix] input must be type 'string', received ${typeof str}`);
  return isHexPrefixed(str) ? str.slice(2) : str;
}
function isHexString(value, length) {
  if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/))
    return false;
  if (typeof length !== "undefined" && length > 0 && value.length !== 2 + 2 * length)
    return false;
  return true;
}

// src/service/evmService.ts
var EvmService = class {
  constructor(auth) {
    this.auth = auth;
  }
  assertEVM() {
    var _a, _b;
    if (((_b = (_a = this.auth.getChain()) == null ? void 0 : _a.name) == null ? void 0 : _b.toLowerCase()) === "solana") {
      throw AuthError.unsupportedMethod();
    }
  }
  sendTransaction(transaction) {
    return __async(this, null, function* () {
      this.assertEVM();
      return this.auth.sendTransaction(addHexPrefix(Buffer5.from(JSON.stringify(transaction)).toString("hex")));
    });
  }
  personalSign(message) {
    return __async(this, null, function* () {
      this.assertEVM();
      return this.auth.sign("personal_sign", message);
    });
  }
  personalSignUniq(message) {
    return __async(this, null, function* () {
      this.assertEVM();
      return this.auth.sign("personal_sign_uniq", message);
    });
  }
  signTypedData(_0) {
    return __async(this, arguments, function* ({
      data,
      version: version2
    }) {
      this.assertEVM();
      return this.auth.sign(
        `eth_signTypedData_${version2.toLowerCase()}`,
        addHexPrefix(Buffer5.from(JSON.stringify(data)).toString("hex"))
      );
    });
  }
  signTypedDataUniq(data) {
    return __async(this, null, function* () {
      this.assertEVM();
      return this.auth.sign(
        "eth_signTypedData_v4_uniq",
        addHexPrefix(Buffer5.from(JSON.stringify(data)).toString("hex"))
      );
    });
  }
  getAddress() {
    return __async(this, null, function* () {
      return this.auth.getEVMAddress();
    });
  }
  getRpcUrl() {
    this.assertEVM();
    const domain = `${rpcUrl()}/evm-chain`;
    return `${domain}?chainId=${this.auth.getChain().id}&projectUuid=${this.auth.config.projectId}&projectKey=${this.auth.config.clientKey}`;
  }
};
var evmService_default = EvmService;

// src/service/solanaService.ts
import { Buffer as Buffer6 } from "buffer";
var SolanaService = class {
  constructor(auth) {
    this.auth = auth;
  }
  assertSolana() {
    var _a, _b;
    if (((_b = (_a = this.auth.getChain()) == null ? void 0 : _a.name) == null ? void 0 : _b.toLowerCase()) !== "solana") {
      throw AuthError.unsupportedMethod();
    }
  }
  signAndSendTransaction(transaction) {
    this.assertSolana();
    return this.auth.sendTransaction(transaction);
  }
  signTransaction(transaction) {
    return __async(this, null, function* () {
      this.assertSolana();
      const tx = yield this.auth.sign("signTransaction", transaction);
      return Buffer6.from(tx, "base64");
    });
  }
  signAllTransactions(transactions) {
    return __async(this, null, function* () {
      this.assertSolana();
      const txs = yield this.auth.signAllTransactions(transactions);
      return txs.map((tx) => Buffer6.from(tx, "base64"));
    });
  }
  signMessage(msg) {
    return __async(this, null, function* () {
      this.assertSolana();
      const signature = yield this.auth.sign("signMessage", msg);
      return Buffer6.from(signature, "base64");
    });
  }
  getAddress() {
    return __async(this, null, function* () {
      return this.auth.getSolanaAddress();
    });
  }
  getRpcUrl() {
    this.assertSolana();
    const domain = `${rpcUrl()}/solana`;
    return `${domain}?chainId=${this.auth.getChain().id}&projectUuid=${this.auth.config.projectId}&projectKey=${this.auth.config.clientKey}`;
  }
};
var solanaService_default = SolanaService;

// src/particle-network.ts
var _bi;
var ParticleNetwork = class {
  constructor(config) {
    this.isParticleNetwork = true;
    __privateAdd(this, _bi, void 0);
    if (!config) {
      config = {
        projectId: "34c6b829-5b89-44e8-90a9-6d982787b9c9",
        clientKey: "c6Z44Ml4TQeNhctvwYgdSv6DBzfjf6t6CB0JDscR",
        appId: "c1ad1496-5707-4db6-8a2b-3e9f7273d846",
        chainName: "Solana",
        chainId: 101,
        preload: true,
        wallet: {
          displayWalletEntry: true,
          defaultWalletEntryPosition: "bottom-right" /* BR */
        }
      };
    }
    if ((!config.chainName || typeof config.chainName === "string") && (!config.chainId || typeof config.chainId === "number") && typeof config.projectId === "string" && typeof config.clientKey === "string" && typeof config.appId === "string") {
      if (config.chainName && config.chainId) {
        const chain = chains2.getChainInfo({
          id: config.chainId,
          name: config.chainName
        });
        if (!chain) {
          throw AuthError.unsupportedChain();
        }
      } else {
        config.chainName = "Ethereum";
        config.chainId = 1;
      }
      this.config = config;
      __privateSet(this, _bi, new BI3({
        sdk_api_domain: apiUrl(),
        device_id: getDeviceId(),
        sdk_version: getVersion(),
        project_config: {
          project_uuid: config.projectId,
          project_key: config.clientKey,
          project_app_uuid: config.appId
        }
      }));
      this.auth = new Auth(this.config, __privateGet(this, _bi));
      this.walletEntryCreate();
      this.evm = new evmService_default(this.auth);
      this.solana = new solanaService_default(this.auth);
      if (typeof window !== "undefined") {
        this.openActive();
        window.particle = this;
      }
    } else {
      throw AuthError.paramsError();
    }
    if ((config == null ? void 0 : config.preload) !== false && typeof window !== "undefined") {
      setTimeout(() => {
        this.preload();
      }, 2e3);
    }
  }
  preload() {
    const url = authUrl();
    const script = document.createElement("script");
    script.src = `${url}/preload.js?_=${Math.floor(Date.now() / 6e4) * 6e4}`;
    script.setAttribute("data-target", "web-auth");
    document.body.appendChild(script);
  }
  openActive() {
    var _a;
    if (this.auth.isLogin() && ((_a = this.auth.getWallet()) == null ? void 0 : _a.public_address)) {
      particleActive(
        __privateGet(this, _bi),
        this.auth.getChainId(),
        this.auth.getWallet().public_address,
        this.auth.getUserInfo(),
        ActiveAction3.OPEN
      );
    }
  }
  setAuthTheme(config) {
    this.auth.setAuthTheme(config);
  }
  getAuthTheme() {
    return this.auth.getAuthTheme();
  }
  switchChain(chain, hideLoading = false) {
    return __async(this, null, function* () {
      return this.auth.switchChain(chain, hideLoading);
    });
  }
  setChainInfo(chain) {
    this.auth.setChainInfo(chain);
  }
  walletEntryDestroy() {
    var _a;
    (_a = this.walletEntry) == null ? void 0 : _a.destroy();
    this.walletEntry = void 0;
  }
  walletEntryCreate() {
    var _a, _b;
    this.walletEntry = new WalletEntryPlugin(this.config, this.auth, {
      position: ((_a = this.config.wallet) == null ? void 0 : _a.defaultWalletEntryPosition) || "bottom-right" /* BR */,
      preload: (_b = this.config.wallet) == null ? void 0 : _b.preload
    });
  }
  openWallet() {
    var _a, _b;
    if (typeof window !== "undefined") {
      if (this.auth.isLogin() && ((_a = this.auth.getWallet()) == null ? void 0 : _a.public_address)) {
        particleActive(
          __privateGet(this, _bi),
          this.auth.getChainId(),
          this.auth.getWallet().public_address,
          this.auth.getUserInfo(),
          ActiveAction3.OPEN_WALLET
        );
      }
      (_b = this.walletEntry) == null ? void 0 : _b.openWallet({
        windowSize: "large"
      });
    }
  }
  buildWalletUrl(config) {
    const url = getWalletUrl(this.auth, config);
    return url;
  }
  openBuy(options, target, features) {
    const url = getBuyUrl(this.auth, options);
    if (typeof window !== "undefined") {
      window.open(url, target, features);
    }
  }
  setLanguage(code) {
    controller.languageCode = code;
  }
  getLanguage() {
    return controller.languageCode;
  }
  get version() {
    return getVersion();
  }
  setFiatCoin(unit) {
    controller.fiatCoin = unit;
  }
  getChain() {
    return this.auth.getChain();
  }
  setERC4337(option) {
    if (typeof option === "boolean" && option) {
      controller.erc4337 = {
        name: "BICONOMY",
        version: "1.0.0"
      };
    } else {
      controller.erc4337 = option;
    }
  }
};
_bi = new WeakMap();
export {
  Auth,
  AuthError,
  AuthTypes,
  ParticleNetwork,
  SettingOption,
  WalletEntryPosition,
  addHexPrefix,
  apiUrl,
  authUrl,
  bufferToHex,
  buyUrl,
  getParticleEnv,
  intToHex,
  isHexPrefixed,
  isHexString,
  isHttpUrl,
  isNullish,
  rpcUrl,
  stripHexPrefix,
  toBase58Address,
  toHexAddress,
  walletUrl
};
//# sourceMappingURL=index.js.map
